// ==================== TRACKVIBES i18n ====================
// Supported languages for DJ interface
export const SUPPORTED_LANGUAGES = ['fr', 'en', 'es', 'de', 'pt'];
export const DEFAULT_LANGUAGE = 'fr';

export const LANGUAGE_NAMES = {
  fr: 'Français',
  en: 'English',
  es: 'Español',
  de: 'Deutsch',
  pt: 'Português'
};

export const LANGUAGE_FLAGS = {
  fr: '🇫🇷',
  en: '🇬🇧',
  es: '🇪🇸',
  de: '🇩🇪',
  pt: '🇵🇹'
};

// ==================== TRANSLATIONS ====================
const translations = {
  // ==================== COMMON ====================
  common: {
    fr: {
      loading: 'Chargement...',
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      close: 'Fermer',
      confirm: 'Confirmer',
      back: 'Retour',
      next: 'Suivant',
      yes: 'Oui',
      no: 'Non',
      error: 'Erreur',
      success: 'Succès',
      warning: 'Attention',
      search: 'Rechercher',
      filter: 'Filtrer',
      all: 'Tous',
      none: 'Aucun',
      or: 'ou',
      and: 'et',
      optional: 'Optionnel',
      required: 'Requis',
      actions: 'Actions',
      settings: 'Paramètres',
      logout: 'Déconnexion',
      login: 'Connexion',
      register: 'Inscription',
      email: 'Email',
      password: 'Mot de passe',
      name: 'Nom',
      language: 'Langue',
      copy: 'Copier',
      copied: 'Copié !',
      download: 'Télécharger',
      share: 'Partager',
      open: 'Ouvrir',
      started_at: 'Démarrée le'
    },
    en: {
      loading: 'Loading...',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      confirm: 'Confirm',
      back: 'Back',
      next: 'Next',
      yes: 'Yes',
      no: 'No',
      error: 'Error',
      success: 'Success',
      warning: 'Warning',
      search: 'Search',
      filter: 'Filter',
      all: 'All',
      none: 'None',
      or: 'or',
      and: 'and',
      optional: 'Optional',
      required: 'Required',
      actions: 'Actions',
      settings: 'Settings',
      logout: 'Logout',
      login: 'Login',
      register: 'Sign up',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      language: 'Language',
      copy: 'Copy',
      copied: 'Copied!',
      download: 'Download',
      share: 'Share',
      open: 'Open',
      started_at: 'Started on'
    },
    es: {
      loading: 'Cargando...',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Cerrar',
      confirm: 'Confirmar',
      back: 'Volver',
      next: 'Siguiente',
      yes: 'Sí',
      no: 'No',
      error: 'Error',
      success: 'Éxito',
      warning: 'Atención',
      search: 'Buscar',
      filter: 'Filtrar',
      all: 'Todos',
      none: 'Ninguno',
      or: 'o',
      and: 'y',
      optional: 'Opcional',
      required: 'Requerido',
      actions: 'Acciones',
      settings: 'Configuración',
      logout: 'Cerrar sesión',
      login: 'Iniciar sesión',
      register: 'Registrarse',
      email: 'Email',
      password: 'Contraseña',
      name: 'Nombre',
      language: 'Idioma',
      copy: 'Copiar',
      copied: '¡Copiado!',
      download: 'Descargar',
      share: 'Compartir',
      open: 'Abrir',
      started_at: 'Iniciada el'
    },
    de: {
      loading: 'Laden...',
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      close: 'Schließen',
      confirm: 'Bestätigen',
      back: 'Zurück',
      next: 'Weiter',
      yes: 'Ja',
      no: 'Nein',
      error: 'Fehler',
      success: 'Erfolg',
      warning: 'Achtung',
      search: 'Suchen',
      filter: 'Filtern',
      all: 'Alle',
      none: 'Keine',
      or: 'oder',
      and: 'und',
      optional: 'Optional',
      required: 'Erforderlich',
      actions: 'Aktionen',
      settings: 'Einstellungen',
      logout: 'Abmelden',
      login: 'Anmelden',
      register: 'Registrieren',
      email: 'E-Mail',
      password: 'Passwort',
      name: 'Name',
      language: 'Sprache',
      copy: 'Kopieren',
      copied: 'Kopiert!',
      download: 'Herunterladen',
      share: 'Teilen',
      open: 'Öffnen',
      started_at: 'Gestartet am'
    },
    pt: {
      loading: 'Carregando...',
      save: 'Salvar',
      cancel: 'Cancelar',
      delete: 'Excluir',
      edit: 'Editar',
      close: 'Fechar',
      confirm: 'Confirmar',
      back: 'Voltar',
      next: 'Próximo',
      yes: 'Sim',
      no: 'Não',
      error: 'Erro',
      success: 'Sucesso',
      warning: 'Atenção',
      search: 'Pesquisar',
      filter: 'Filtrar',
      all: 'Todos',
      none: 'Nenhum',
      or: 'ou',
      and: 'e',
      optional: 'Opcional',
      required: 'Obrigatório',
      actions: 'Ações',
      settings: 'Configurações',
      logout: 'Sair',
      login: 'Entrar',
      register: 'Cadastrar',
      email: 'Email',
      password: 'Senha',
      name: 'Nome',
      language: 'Idioma',
      copy: 'Copiar',
      copied: 'Copiado!',
      download: 'Baixar',
      share: 'Compartilhar',
      open: 'Abrir',
      started_at: 'Iniciado em'
    }
  },

  // ==================== LANDING PAGE ====================
  landing: {
    fr: {
      hero_title: 'Révolutionne tes soirées DJ',
      hero_subtitle: 'Tes invités proposent leurs sons. Tu gardes le contrôle.',
      cta_start: 'Commencer gratuitement',
      cta_demo: 'Voir la démo',
      features_title: 'Pourquoi TrackVibes ?',
      feature_qr_title: 'QR Code intelligent',
      feature_qr_desc: 'Un scan, une demande. Simple et rapide pour tes invités.',
      feature_realtime_title: 'Temps réel',
      feature_realtime_desc: 'Reçois les demandes instantanément sur ton dashboard.',
      feature_stats_title: 'Statistiques',
      feature_stats_desc: 'Analyse les tendances et améliore tes sets.',
      feature_events_title: 'Gestion d\'événements',
      feature_events_desc: 'Organise tes soirées et garde l\'historique.',
      pricing_title: 'Tarifs simples',
      pricing_free: 'Gratuit',
      pricing_free_desc: 'Pour démarrer',
      pricing_pro: 'Pro',
      pricing_pro_desc: 'Pour les pros',
      pricing_lifetime: 'Lifetime',
      pricing_lifetime_desc: 'Accès à vie',
      footer_made: 'Fait avec ❤️ pour les DJs'
    },
    en: {
      hero_title: 'Revolutionize your DJ sets',
      hero_subtitle: 'Your guests request songs. You stay in control.',
      cta_start: 'Start for free',
      cta_demo: 'See demo',
      features_title: 'Why TrackVibes?',
      feature_qr_title: 'Smart QR Code',
      feature_qr_desc: 'One scan, one request. Simple and fast for your guests.',
      feature_realtime_title: 'Real-time',
      feature_realtime_desc: 'Receive requests instantly on your dashboard.',
      feature_stats_title: 'Statistics',
      feature_stats_desc: 'Analyze trends and improve your sets.',
      feature_events_title: 'Event management',
      feature_events_desc: 'Organize your events and keep history.',
      pricing_title: 'Simple pricing',
      pricing_free: 'Free',
      pricing_free_desc: 'To get started',
      pricing_pro: 'Pro',
      pricing_pro_desc: 'For professionals',
      pricing_lifetime: 'Lifetime',
      pricing_lifetime_desc: 'Lifetime access',
      footer_made: 'Made with ❤️ for DJs'
    },
    es: {
      hero_title: 'Revoluciona tus sesiones DJ',
      hero_subtitle: 'Tus invitados piden canciones. Tú mantienes el control.',
      cta_start: 'Empezar gratis',
      cta_demo: 'Ver demo',
      features_title: '¿Por qué TrackVibes?',
      feature_qr_title: 'Código QR inteligente',
      feature_qr_desc: 'Un escaneo, una solicitud. Simple y rápido.',
      feature_realtime_title: 'Tiempo real',
      feature_realtime_desc: 'Recibe solicitudes al instante en tu panel.',
      feature_stats_title: 'Estadísticas',
      feature_stats_desc: 'Analiza tendencias y mejora tus sets.',
      feature_events_title: 'Gestión de eventos',
      feature_events_desc: 'Organiza tus fiestas y guarda el historial.',
      pricing_title: 'Precios simples',
      pricing_free: 'Gratis',
      pricing_free_desc: 'Para empezar',
      pricing_pro: 'Pro',
      pricing_pro_desc: 'Para profesionales',
      pricing_lifetime: 'Lifetime',
      pricing_lifetime_desc: 'Acceso de por vida',
      footer_made: 'Hecho con ❤️ para DJs'
    },
    de: {
      hero_title: 'Revolutioniere deine DJ-Sets',
      hero_subtitle: 'Deine Gäste wünschen Songs. Du behältst die Kontrolle.',
      cta_start: 'Kostenlos starten',
      cta_demo: 'Demo ansehen',
      features_title: 'Warum TrackVibes?',
      feature_qr_title: 'Intelligenter QR-Code',
      feature_qr_desc: 'Ein Scan, eine Anfrage. Einfach und schnell.',
      feature_realtime_title: 'Echtzeit',
      feature_realtime_desc: 'Erhalte Anfragen sofort auf deinem Dashboard.',
      feature_stats_title: 'Statistiken',
      feature_stats_desc: 'Analysiere Trends und verbessere deine Sets.',
      feature_events_title: 'Event-Verwaltung',
      feature_events_desc: 'Organisiere deine Events und behalte den Verlauf.',
      pricing_title: 'Einfache Preise',
      pricing_free: 'Kostenlos',
      pricing_free_desc: 'Zum Starten',
      pricing_pro: 'Pro',
      pricing_pro_desc: 'Für Profis',
      pricing_lifetime: 'Lifetime',
      pricing_lifetime_desc: 'Lebenslanger Zugang',
      footer_made: 'Mit ❤️ für DJs gemacht'
    },
    pt: {
      hero_title: 'Revolucione suas festas DJ',
      hero_subtitle: 'Seus convidados pedem músicas. Você mantém o controle.',
      cta_start: 'Começar grátis',
      cta_demo: 'Ver demo',
      features_title: 'Por que TrackVibes?',
      feature_qr_title: 'QR Code inteligente',
      feature_qr_desc: 'Um scan, um pedido. Simples e rápido.',
      feature_realtime_title: 'Tempo real',
      feature_realtime_desc: 'Receba pedidos instantaneamente no seu painel.',
      feature_stats_title: 'Estatísticas',
      feature_stats_desc: 'Analise tendências e melhore seus sets.',
      feature_events_title: 'Gestão de eventos',
      feature_events_desc: 'Organize suas festas e guarde o histórico.',
      pricing_title: 'Preços simples',
      pricing_free: 'Grátis',
      pricing_free_desc: 'Para começar',
      pricing_pro: 'Pro',
      pricing_pro_desc: 'Para profissionais',
      pricing_lifetime: 'Lifetime',
      pricing_lifetime_desc: 'Acesso vitalício',
      footer_made: 'Feito com ❤️ para DJs'
    }
  },

  // ==================== AUTH (Login/Register) ====================
  auth: {
    fr: {
      login_title: 'Connexion DJ',
      login_subtitle: 'Accède à ton espace DJ',
      register_title: 'Créer un compte DJ',
      register_subtitle: 'Rejoins la communauté TrackVibes',
      dj_name: 'Nom de DJ',
      dj_name_placeholder: 'Ex: DJ Mike',
      email_placeholder: 'ton@email.com',
      password_placeholder: 'Ton mot de passe',
      confirm_password: 'Confirmer le mot de passe',
      forgot_password: 'Mot de passe oublié ?',
      no_account: 'Pas encore de compte ?',
      have_account: 'Déjà un compte ?',
      login_button: 'Se connecter',
      register_button: 'Créer mon compte',
      terms_agree: 'J\'accepte les',
      terms_link: 'conditions d\'utilisation',
      select_language: 'Langue de l\'interface',
      verification_sent: 'Email de vérification envoyé !',
      check_inbox: 'Vérifie ta boîte mail pour activer ton compte.'
    },
    en: {
      login_title: 'DJ Login',
      login_subtitle: 'Access your DJ space',
      register_title: 'Create DJ account',
      register_subtitle: 'Join the TrackVibes community',
      dj_name: 'DJ Name',
      dj_name_placeholder: 'Ex: DJ Mike',
      email_placeholder: 'your@email.com',
      password_placeholder: 'Your password',
      confirm_password: 'Confirm password',
      forgot_password: 'Forgot password?',
      no_account: 'No account yet?',
      have_account: 'Already have an account?',
      login_button: 'Log in',
      register_button: 'Create my account',
      terms_agree: 'I agree to the',
      terms_link: 'terms of use',
      select_language: 'Interface language',
      verification_sent: 'Verification email sent!',
      check_inbox: 'Check your inbox to activate your account.'
    },
    es: {
      login_title: 'Inicio de sesión DJ',
      login_subtitle: 'Accede a tu espacio DJ',
      register_title: 'Crear cuenta DJ',
      register_subtitle: 'Únete a la comunidad TrackVibes',
      dj_name: 'Nombre de DJ',
      dj_name_placeholder: 'Ej: DJ Mike',
      email_placeholder: 'tu@email.com',
      password_placeholder: 'Tu contraseña',
      confirm_password: 'Confirmar contraseña',
      forgot_password: '¿Olvidaste tu contraseña?',
      no_account: '¿No tienes cuenta?',
      have_account: '¿Ya tienes cuenta?',
      login_button: 'Iniciar sesión',
      register_button: 'Crear mi cuenta',
      terms_agree: 'Acepto los',
      terms_link: 'términos de uso',
      select_language: 'Idioma de la interfaz',
      verification_sent: '¡Email de verificación enviado!',
      check_inbox: 'Revisa tu bandeja de entrada para activar tu cuenta.'
    },
    de: {
      login_title: 'DJ-Anmeldung',
      login_subtitle: 'Zugang zu deinem DJ-Bereich',
      register_title: 'DJ-Konto erstellen',
      register_subtitle: 'Tritt der TrackVibes-Community bei',
      dj_name: 'DJ-Name',
      dj_name_placeholder: 'Z.B.: DJ Mike',
      email_placeholder: 'deine@email.com',
      password_placeholder: 'Dein Passwort',
      confirm_password: 'Passwort bestätigen',
      forgot_password: 'Passwort vergessen?',
      no_account: 'Noch kein Konto?',
      have_account: 'Bereits ein Konto?',
      login_button: 'Anmelden',
      register_button: 'Mein Konto erstellen',
      terms_agree: 'Ich akzeptiere die',
      terms_link: 'Nutzungsbedingungen',
      select_language: 'Sprache der Oberfläche',
      verification_sent: 'Bestätigungs-E-Mail gesendet!',
      check_inbox: 'Überprüfe deinen Posteingang, um dein Konto zu aktivieren.'
    },
    pt: {
      login_title: 'Login DJ',
      login_subtitle: 'Acesse seu espaço DJ',
      register_title: 'Criar conta DJ',
      register_subtitle: 'Junte-se à comunidade TrackVibes',
      dj_name: 'Nome de DJ',
      dj_name_placeholder: 'Ex: DJ Mike',
      email_placeholder: 'seu@email.com',
      password_placeholder: 'Sua senha',
      confirm_password: 'Confirmar senha',
      forgot_password: 'Esqueceu a senha?',
      no_account: 'Ainda não tem conta?',
      have_account: 'Já tem uma conta?',
      login_button: 'Entrar',
      register_button: 'Criar minha conta',
      terms_agree: 'Eu aceito os',
      terms_link: 'termos de uso',
      select_language: 'Idioma da interface',
      verification_sent: 'Email de verificação enviado!',
      check_inbox: 'Verifique sua caixa de entrada para ativar sua conta.'
    }
  },

  // ==================== DASHBOARD ====================
  dashboard: {
    fr: {
      title: 'Dashboard',
      welcome: 'Bienvenue',
      requests: 'Demandes',
      new_requests: 'Nouvelles demandes',
      no_requests: 'Aucune demande',
      waiting_requests: 'En attente de tes invités...',
      total_requests: 'Total des demandes',
      played: 'Joués',
      pending: 'En attente',
      mark_played: 'Marquer comme joué',
      mark_unplayed: 'Marquer comme non joué',
      delete_request: 'Supprimer cette demande',
      sound_on: 'Son activé',
      sound_off: 'Son désactivé',
      notifications_on: 'Notifications activées',
      notifications_off: 'Activer les notifications',
      active_event: 'Événement actif',
      no_active_event: 'Aucun événement actif',
      start_event: 'Démarrer un événement',
      requests_open: 'Demandes ouvertes',
      requests_closed: 'Demandes fermées',
      requests_open_desc: 'Les clients peuvent soumettre des demandes',
      requests_closed_desc: 'Les clients ne peuvent plus soumettre de demandes',
      from_event: 'depuis l\'événement',
      upgrade_pro: 'Passer Pro',
      new_count: 'nouveau',
      new_count_plural: 'nouveaux',
      tap_to_enable_sound: 'Touchez pour activer le son',
      enable_notifications: 'Active les notifications push',
      enable_notifications_desc: 'Sois alerté même quand tu ne regardes pas l\'écran',
      enable_btn: 'Activer',
      filter_active: 'À traiter',
      filter_all: 'Toutes',
      filter_received: 'Reçues',
      filter_pending: 'En attente',
      filter_played: 'Jouées',
      filter_refused: 'Refusées',
      sort_recent: 'Plus récentes',
      sort_likes: 'Plus likés',
      refuse: 'Refuser',
      refuse_reason: 'Raison du refus',
      refuse_already_played: 'Déjà passée pendant la soirée',
      refuse_not_in_theme: 'Ne correspond pas au thème',
      refuse_already_requested: 'Déjà demandée par quelqu\'un d\'autre',
      refused_label: 'Refusée',
      anonymous: 'Anonyme',
      likes: 'likes',
      open_spotify: 'Ouvrir sur Spotify',
      search_youtube: 'Chercher sur YouTube',
      // Stats cards
      stat_received: 'Reçues',
      stat_pending: 'En attente',
      stat_played: 'Jouées',
      stat_refused: 'Refusées',
      stat_total: 'Total',
      stat_tips: 'Pourboires',
      // Founder offer
      founder_offer: 'Offre Fondateur : les 100 premiers DJs bénéficient du tarif 4,99€/mois à vie.',
      founder_cta: 'En profiter',
      // Active event banner
      event_live: 'Soirée en cours',
      event_live_badge: 'EN DIRECT',
      // Request actions
      refresh: 'Actualiser',
      action_pending: 'Attente',
      action_played: 'Jouée',
      action_refuse: 'Refuser',
      action_requeue: 'Remettre en file',
      action_cancel_refuse: 'Annuler le refus',
      action_delete: 'Supprimer',
      // Request badges
      badge_new: 'Nouveau',
      badge_tip: 'Pourboire',
      badge_very_supported: 'Très soutenu',
      badge_vote: 'vote',
      badge_votes: 'votes',
      // Modal
      from_client: 'De',
      link_label: 'Lien',
      status_received: 'Reçue',
      status_pending: 'En attente',
      status_played: 'Jouée',
      status_refused: 'Refusée'
    },
    en: {
      title: 'Dashboard',
      welcome: 'Welcome',
      requests: 'Requests',
      new_requests: 'New requests',
      no_requests: 'No requests',
      waiting_requests: 'Waiting for your guests...',
      total_requests: 'Total requests',
      played: 'Played',
      pending: 'Pending',
      mark_played: 'Mark as played',
      mark_unplayed: 'Mark as not played',
      delete_request: 'Delete this request',
      sound_on: 'Sound on',
      sound_off: 'Sound off',
      notifications_on: 'Notifications on',
      notifications_off: 'Enable notifications',
      active_event: 'Active event',
      no_active_event: 'No active event',
      start_event: 'Start an event',
      requests_open: 'Requests open',
      requests_closed: 'Requests closed',
      requests_open_desc: 'Clients can submit requests',
      requests_closed_desc: 'Clients can no longer submit requests',
      from_event: 'from event',
      upgrade_pro: 'Go Pro',
      new_count: 'new',
      new_count_plural: 'new',
      tap_to_enable_sound: 'Tap to enable sound',
      enable_notifications: 'Enable push notifications',
      enable_notifications_desc: 'Get alerts even when not looking at the screen',
      enable_btn: 'Enable',
      filter_active: 'To play',
      filter_all: 'All',
      filter_received: 'Received',
      filter_pending: 'Pending',
      filter_played: 'Played',
      filter_refused: 'Refused',
      sort_recent: 'Most recent',
      sort_likes: 'Most liked',
      refuse: 'Refuse',
      refuse_reason: 'Reason for refusal',
      refuse_already_played: 'Already played during the party',
      refuse_not_in_theme: 'Does not match the theme',
      refuse_already_requested: 'Already requested by someone else',
      refused_label: 'Refused',
      anonymous: 'Anonymous',
      likes: 'likes',
      open_spotify: 'Open on Spotify',
      search_youtube: 'Search on YouTube',
      // Stats cards
      stat_received: 'Received',
      stat_pending: 'Pending',
      stat_played: 'Played',
      stat_refused: 'Refused',
      stat_total: 'Total',
      stat_tips: 'Tips',
      // Founder offer
      founder_offer: 'Founder Offer: the first 100 DJs get the €4.99/month rate for life.',
      founder_cta: 'Get it',
      // Active event banner
      event_live: 'Event in progress',
      event_live_badge: 'LIVE',
      // Request actions
      refresh: 'Refresh',
      action_pending: 'Pending',
      action_played: 'Played',
      action_refuse: 'Refuse',
      action_requeue: 'Requeue',
      action_cancel_refuse: 'Cancel refusal',
      action_delete: 'Delete',
      // Request badges
      badge_new: 'New',
      badge_tip: 'Tip',
      badge_very_supported: 'Very supported',
      badge_vote: 'vote',
      badge_votes: 'votes',
      // Modal
      from_client: 'From',
      link_label: 'Link',
      status_received: 'Received',
      status_pending: 'Pending',
      status_played: 'Played',
      status_refused: 'Refused'
    },
    es: {
      title: 'Panel',
      welcome: 'Bienvenido',
      requests: 'Solicitudes',
      new_requests: 'Nuevas solicitudes',
      no_requests: 'Sin solicitudes',
      waiting_requests: 'Esperando a tus invitados...',
      total_requests: 'Total de solicitudes',
      played: 'Reproducidos',
      pending: 'Pendientes',
      mark_played: 'Marcar como reproducido',
      mark_unplayed: 'Marcar como no reproducido',
      delete_request: 'Eliminar esta solicitud',
      sound_on: 'Sonido activado',
      sound_off: 'Sonido desactivado',
      notifications_on: 'Notificaciones activadas',
      notifications_off: 'Activar notificaciones',
      active_event: 'Evento activo',
      no_active_event: 'Sin evento activo',
      start_event: 'Iniciar un evento',
      requests_open: 'Solicitudes abiertas',
      requests_closed: 'Solicitudes cerradas',
      requests_open_desc: 'Los clientes pueden enviar solicitudes',
      requests_closed_desc: 'Los clientes ya no pueden enviar solicitudes',
      from_event: 'del evento',
      upgrade_pro: 'Pasar a Pro',
      new_count: 'nuevo',
      new_count_plural: 'nuevos',
      tap_to_enable_sound: 'Toca para activar el sonido',
      enable_notifications: 'Activa las notificaciones push',
      enable_notifications_desc: 'Recibe alertas incluso cuando no miras la pantalla',
      enable_btn: 'Activar',
      filter_active: 'Por tocar',
      filter_all: 'Todas',
      filter_received: 'Recibidas',
      filter_pending: 'Pendientes',
      filter_played: 'Reproducidas',
      filter_refused: 'Rechazadas',
      sort_recent: 'Más recientes',
      sort_likes: 'Más gustadas',
      refuse: 'Rechazar',
      refuse_reason: 'Razón del rechazo',
      refuse_already_played: 'Ya se reprodujo durante la fiesta',
      refuse_not_in_theme: 'No corresponde al tema',
      refuse_already_requested: 'Ya solicitada por alguien más',
      refused_label: 'Rechazada',
      anonymous: 'Anónimo',
      likes: 'me gusta',
      open_spotify: 'Abrir en Spotify',
      search_youtube: 'Buscar en YouTube',
      // Stats cards
      stat_received: 'Recibidas',
      stat_pending: 'Pendientes',
      stat_played: 'Reproducidas',
      stat_refused: 'Rechazadas',
      stat_total: 'Total',
      stat_tips: 'Propinas',
      // Founder offer
      founder_offer: 'Oferta Fundador: los primeros 100 DJs obtienen la tarifa de 4,99€/mes de por vida.',
      founder_cta: 'Aprovéchalo',
      // Active event banner
      event_live: 'Evento en curso',
      event_live_badge: 'EN VIVO',
      // Request actions
      refresh: 'Actualizar',
      action_pending: 'Pendiente',
      action_played: 'Reproducida',
      action_refuse: 'Rechazar',
      action_requeue: 'Volver a la cola',
      action_cancel_refuse: 'Cancelar rechazo',
      action_delete: 'Eliminar',
      // Request badges
      badge_new: 'Nuevo',
      badge_tip: 'Propina',
      badge_very_supported: 'Muy apoyado',
      badge_vote: 'voto',
      badge_votes: 'votos',
      // Modal
      from_client: 'De',
      link_label: 'Enlace',
      status_received: 'Recibida',
      status_pending: 'Pendiente',
      status_played: 'Reproducida',
      status_refused: 'Rechazada'
    },
    de: {
      title: 'Dashboard',
      welcome: 'Willkommen',
      requests: 'Anfragen',
      new_requests: 'Neue Anfragen',
      no_requests: 'Keine Anfragen',
      waiting_requests: 'Warte auf deine Gäste...',
      total_requests: 'Gesamtanfragen',
      played: 'Gespielt',
      pending: 'Ausstehend',
      mark_played: 'Als gespielt markieren',
      mark_unplayed: 'Als nicht gespielt markieren',
      delete_request: 'Diese Anfrage löschen',
      sound_on: 'Ton an',
      sound_off: 'Ton aus',
      notifications_on: 'Benachrichtigungen an',
      notifications_off: 'Benachrichtigungen aktivieren',
      active_event: 'Aktives Event',
      no_active_event: 'Kein aktives Event',
      start_event: 'Event starten',
      requests_open: 'Anfragen offen',
      requests_closed: 'Anfragen geschlossen',
      requests_open_desc: 'Kunden können Anfragen senden',
      requests_closed_desc: 'Kunden können keine Anfragen mehr senden',
      from_event: 'vom Event',
      upgrade_pro: 'Pro werden',
      new_count: 'neu',
      new_count_plural: 'neue',
      tap_to_enable_sound: 'Tippen zum Aktivieren',
      enable_notifications: 'Push-Benachrichtigungen aktivieren',
      enable_notifications_desc: 'Erhalte Alerts auch wenn du nicht auf den Bildschirm schaust',
      enable_btn: 'Aktivieren',
      filter_active: 'Zu spielen',
      filter_all: 'Alle',
      filter_received: 'Empfangen',
      filter_pending: 'Ausstehend',
      filter_played: 'Gespielt',
      filter_refused: 'Abgelehnt',
      sort_recent: 'Neueste',
      sort_likes: 'Meiste Likes',
      refuse: 'Ablehnen',
      refuse_reason: 'Ablehnungsgrund',
      refuse_already_played: 'Bereits während der Party gespielt',
      refuse_not_in_theme: 'Passt nicht zum Thema',
      refuse_already_requested: 'Bereits von jemand anderem angefragt',
      refused_label: 'Abgelehnt',
      anonymous: 'Anonym',
      likes: 'Likes',
      open_spotify: 'Auf Spotify öffnen',
      search_youtube: 'Auf YouTube suchen',
      // Stats cards
      stat_received: 'Empfangen',
      stat_pending: 'Ausstehend',
      stat_played: 'Gespielt',
      stat_refused: 'Abgelehnt',
      stat_total: 'Gesamt',
      stat_tips: 'Trinkgelder',
      // Founder offer
      founder_offer: 'Gründerangebot: Die ersten 100 DJs erhalten den Tarif von 4,99€/Monat lebenslang.',
      founder_cta: 'Jetzt sichern',
      // Active event banner
      event_live: 'Event läuft',
      event_live_badge: 'LIVE',
      // Request actions
      refresh: 'Aktualisieren',
      action_pending: 'Ausstehend',
      action_played: 'Gespielt',
      action_refuse: 'Ablehnen',
      action_requeue: 'Zurück in die Warteschlange',
      action_cancel_refuse: 'Ablehnung aufheben',
      action_delete: 'Löschen',
      // Request badges
      badge_new: 'Neu',
      badge_tip: 'Trinkgeld',
      badge_very_supported: 'Sehr unterstützt',
      badge_vote: 'Stimme',
      badge_votes: 'Stimmen',
      // Modal
      from_client: 'Von',
      link_label: 'Link',
      status_received: 'Empfangen',
      status_pending: 'Ausstehend',
      status_played: 'Gespielt',
      status_refused: 'Abgelehnt'
    },
    pt: {
      title: 'Painel',
      welcome: 'Bem-vindo',
      requests: 'Pedidos',
      new_requests: 'Novos pedidos',
      no_requests: 'Nenhum pedido',
      waiting_requests: 'Aguardando seus convidados...',
      total_requests: 'Total de pedidos',
      played: 'Tocados',
      pending: 'Pendentes',
      mark_played: 'Marcar como tocado',
      mark_unplayed: 'Marcar como não tocado',
      delete_request: 'Excluir este pedido',
      sound_on: 'Som ativado',
      sound_off: 'Som desativado',
      notifications_on: 'Notificações ativadas',
      notifications_off: 'Ativar notificações',
      active_event: 'Evento ativo',
      no_active_event: 'Nenhum evento ativo',
      start_event: 'Iniciar um evento',
      requests_open: 'Pedidos abertos',
      requests_closed: 'Pedidos fechados',
      requests_open_desc: 'Os clientes podem enviar pedidos',
      requests_closed_desc: 'Os clientes não podem mais enviar pedidos',
      from_event: 'do evento',
      upgrade_pro: 'Seja Pro',
      new_count: 'novo',
      new_count_plural: 'novos',
      tap_to_enable_sound: 'Toque para ativar o som',
      enable_notifications: 'Ative as notificações push',
      enable_notifications_desc: 'Receba alertas mesmo quando não estiver olhando a tela',
      enable_btn: 'Ativar',
      filter_active: 'A tocar',
      filter_all: 'Todos',
      filter_received: 'Recebidos',
      filter_pending: 'Pendentes',
      filter_played: 'Tocados',
      filter_refused: 'Recusados',
      sort_recent: 'Mais recentes',
      sort_likes: 'Mais curtidos',
      refuse: 'Recusar',
      refuse_reason: 'Motivo da recusa',
      refuse_already_played: 'Já tocada durante a festa',
      refuse_not_in_theme: 'Não corresponde ao tema',
      refuse_already_requested: 'Já pedida por outra pessoa',
      refused_label: 'Recusado',
      anonymous: 'Anônimo',
      likes: 'curtidas',
      open_spotify: 'Abrir no Spotify',
      search_youtube: 'Buscar no YouTube',
      // Stats cards
      stat_received: 'Recebidos',
      stat_pending: 'Pendentes',
      stat_played: 'Tocados',
      stat_refused: 'Recusados',
      stat_total: 'Total',
      stat_tips: 'Gorjetas',
      // Founder offer
      founder_offer: 'Oferta Fundador: os primeiros 100 DJs têm a tarifa de 4,99€/mês para sempre.',
      founder_cta: 'Aproveitar',
      // Active event banner
      event_live: 'Evento em andamento',
      event_live_badge: 'AO VIVO',
      // Request actions
      refresh: 'Atualizar',
      action_pending: 'Pendente',
      action_played: 'Tocada',
      action_refuse: 'Recusar',
      action_requeue: 'Voltar para fila',
      action_cancel_refuse: 'Cancelar recusa',
      action_delete: 'Excluir',
      // Request badges
      badge_new: 'Novo',
      badge_tip: 'Gorjeta',
      badge_very_supported: 'Muito apoiado',
      badge_vote: 'voto',
      badge_votes: 'votos',
      // Modal
      from_client: 'De',
      link_label: 'Link',
      status_received: 'Recebido',
      status_pending: 'Pendente',
      status_played: 'Tocado',
      status_refused: 'Recusado'
    }
  },

  // ==================== EVENTS ====================
  events: {
    fr: {
      title: 'Mes soirées',
      new_event: 'Nouvelle soirée',
      no_events: 'Aucune soirée créée',
      create_first: 'Crée ta première soirée !',
      event_name: 'Nom de la soirée',
      event_type: 'Type d\'événement',
      event_date: 'Date',
      event_location: 'Lieu',
      event_guests: 'Nombre de personnes',
      status_draft: 'Brouillon',
      status_active: 'En cours',
      status_closed: 'Terminé',
      activate: 'Activer (Jour J)',
      close_event: 'Clôturer',
      reopen: 'Réouvrir les demandes',
      view_details: 'Voir les détails',
      open_form: 'Ouvrir le formulaire client',
      copy_link: 'Copier le lien',
      download_qr: 'Télécharger QR',
      download_poster: 'Télécharger l\'affiche',
      music_prefs: 'Goûts / règles musicales',
      authority_label: 'Donneur d\'ordre',
      authority_banned: 'Interdits',
      authority_loves: 'Envies',
      // Additional keys
      global_stats: 'Statistiques globales',
      events_count: 'Soirées',
      total_requests: 'Demandes totales',
      played: 'Jouées',
      donations: 'Dons',
      pro_reports: 'Rapports PRO',
      download_reports: 'Télécharge tes rapports détaillés au format PDF',
      monthly_report: 'Rapport mensuel (en cours)',
      annual_report: 'Rapport annuel (en cours)',
      custom_report: 'Rapport personnalisé',
      start_date: 'Date début',
      end_date: 'Date fin',
      generate: 'Générer',
      event_in_progress: 'Soirée en cours',
      live_stats: 'Stats live',
      close: 'Clôturer',
      my_events: 'Mes soirées',
      upcoming: 'À venir',
      closed: 'Clôturées',
      no_upcoming: 'Aucune soirée à venir',
      no_closed: 'Aucune soirée clôturée',
      create_first_hint: 'Crée ta première soirée pour commencer !',
      requests: 'demande',
      requests_plural: 'demandes',
      open: 'Ouvert',
      closed_status: 'Fermé',
      link_copied: 'Lien copié',
      copy_failed: 'Copie impossible',
      copy: 'Copier',
      share: 'Partager',
      poster_a4: 'Affiche A4',
      poster_a5: 'Cartes A5',
      link_unavailable: 'Lien indisponible',
      modify: 'Modifier',
      delete: 'Supprimer',
      duration: 'Durée',
      participants: 'Participants',
      pending: 'En attente',
      refused: 'Refusées',
      total_tips: 'Total des dons',
      top_songs: 'Top chansons',
      played_status: 'Jouée',
      // PRO paywall
      pro_feature: 'Fonctionnalité Pro',
      pro_feature_desc: 'Les statistiques avancées et la gestion de soirées sont disponibles en version Pro.',
      pro_includes: 'Inclus dans Pro :',
      pro_create_events: 'Créer et gérer des soirées/prestations',
      pro_detailed_stats: 'Statistiques détaillées par événement',
      pro_history: 'Historique complet des prestations',
      pro_top_songs: 'Top songs et analytics',
      coming_soon: 'Bientôt disponible',
      types: {
        mariage: 'Mariage',
        club: 'Club',
        bar: 'Bar',
        anniversaire: 'Anniversaire',
        entreprise: 'Entreprise',
        autre: 'Autre'
      },
      // Event requests view
      event_requests: 'Demandes de l\'événement',
      view_requests: 'Voir les demandes',
      all_requests: 'Toutes',
      pending_requests: 'En attente',
      played_requests: 'Jouées',
      refused_requests: 'Refusées',
      search_requests: 'Rechercher...',
      sort_by_date: 'Par date',
      sort_by_likes: 'Par likes',
      no_requests: 'Aucune demande',
      no_requests_hint: 'Aucune demande pour cet événement',
      requested_by: 'Demandé par',
      request_status: 'Statut'
    },
    en: {
      title: 'My events',
      new_event: 'New event',
      no_events: 'No events created',
      create_first: 'Create your first event!',
      event_name: 'Event name',
      event_type: 'Event type',
      event_date: 'Date',
      event_location: 'Location',
      event_guests: 'Number of guests',
      status_draft: 'Draft',
      status_active: 'Active',
      status_closed: 'Closed',
      activate: 'Activate (D-Day)',
      close_event: 'Close',
      reopen: 'Reopen requests',
      view_details: 'View details',
      open_form: 'Open client form',
      copy_link: 'Copy link',
      download_qr: 'Download QR',
      download_poster: 'Download poster',
      music_prefs: 'Music preferences',
      authority_label: 'Decision maker',
      authority_banned: 'Banned',
      authority_loves: 'Wishes',
      // Additional keys
      global_stats: 'Global statistics',
      events_count: 'Events',
      total_requests: 'Total requests',
      played: 'Played',
      donations: 'Donations',
      pro_reports: 'PRO Reports',
      download_reports: 'Download your detailed reports in PDF format',
      monthly_report: 'Monthly report (current)',
      annual_report: 'Annual report (current)',
      custom_report: 'Custom report',
      start_date: 'Start date',
      end_date: 'End date',
      generate: 'Generate',
      event_in_progress: 'Event in progress',
      live_stats: 'Live stats',
      close: 'Close',
      my_events: 'My events',
      upcoming: 'Upcoming',
      closed: 'Closed',
      no_upcoming: 'No upcoming events',
      no_closed: 'No closed events',
      create_first_hint: 'Create your first event to get started!',
      requests: 'request',
      requests_plural: 'requests',
      open: 'Open',
      closed_status: 'Closed',
      link_copied: 'Link copied',
      copy_failed: 'Copy failed',
      copy: 'Copy',
      share: 'Share',
      poster_a4: 'A4 Poster',
      poster_a5: 'A5 Cards',
      link_unavailable: 'Link unavailable',
      modify: 'Edit',
      delete: 'Delete',
      duration: 'Duration',
      participants: 'Participants',
      pending: 'Pending',
      refused: 'Refused',
      total_tips: 'Total donations',
      top_songs: 'Top songs',
      played_status: 'Played',
      // PRO paywall
      pro_feature: 'Pro Feature',
      pro_feature_desc: 'Advanced statistics and event management are available in the Pro version.',
      pro_includes: 'Included in Pro:',
      pro_create_events: 'Create and manage events',
      pro_detailed_stats: 'Detailed statistics per event',
      pro_history: 'Complete event history',
      pro_top_songs: 'Top songs and analytics',
      coming_soon: 'Coming soon',
      types: {
        mariage: 'Wedding',
        club: 'Club',
        bar: 'Bar',
        anniversaire: 'Birthday',
        entreprise: 'Corporate',
        autre: 'Other'
      },
      // Event requests view
      event_requests: 'Event requests',
      view_requests: 'View requests',
      all_requests: 'All',
      pending_requests: 'Pending',
      played_requests: 'Played',
      refused_requests: 'Refused',
      search_requests: 'Search...',
      sort_by_date: 'By date',
      sort_by_likes: 'By likes',
      no_requests: 'No requests',
      no_requests_hint: 'No requests for this event',
      requested_by: 'Requested by',
      request_status: 'Status'
    },
    es: {
      title: 'Mis eventos',
      new_event: 'Nuevo evento',
      no_events: 'Sin eventos creados',
      create_first: '¡Crea tu primer evento!',
      event_name: 'Nombre del evento',
      event_type: 'Tipo de evento',
      event_date: 'Fecha',
      event_location: 'Lugar',
      event_guests: 'Número de invitados',
      status_draft: 'Borrador',
      status_active: 'Activo',
      status_closed: 'Cerrado',
      activate: 'Activar (Día D)',
      close_event: 'Cerrar',
      reopen: 'Reabrir solicitudes',
      view_details: 'Ver detalles',
      open_form: 'Abrir formulario',
      copy_link: 'Copiar enlace',
      download_qr: 'Descargar QR',
      download_poster: 'Descargar cartel',
      music_prefs: 'Preferencias musicales',
      authority_label: 'Responsable',
      authority_banned: 'Prohibidos',
      authority_loves: 'Deseos',
      // Additional keys
      global_stats: 'Estadísticas globales',
      events_count: 'Eventos',
      total_requests: 'Solicitudes totales',
      played: 'Reproducidas',
      donations: 'Donaciones',
      pro_reports: 'Informes PRO',
      download_reports: 'Descarga tus informes detallados en formato PDF',
      monthly_report: 'Informe mensual (actual)',
      annual_report: 'Informe anual (actual)',
      custom_report: 'Informe personalizado',
      start_date: 'Fecha inicio',
      end_date: 'Fecha fin',
      generate: 'Generar',
      event_in_progress: 'Evento en curso',
      live_stats: 'Stats en vivo',
      close: 'Cerrar',
      my_events: 'Mis eventos',
      upcoming: 'Próximos',
      closed: 'Cerrados',
      no_upcoming: 'Sin eventos próximos',
      no_closed: 'Sin eventos cerrados',
      create_first_hint: '¡Crea tu primer evento para comenzar!',
      requests: 'solicitud',
      requests_plural: 'solicitudes',
      open: 'Abierto',
      closed_status: 'Cerrado',
      link_copied: 'Enlace copiado',
      copy_failed: 'Copia fallida',
      copy: 'Copiar',
      share: 'Compartir',
      poster_a4: 'Cartel A4',
      poster_a5: 'Tarjetas A5',
      link_unavailable: 'Enlace no disponible',
      modify: 'Modificar',
      delete: 'Eliminar',
      duration: 'Duración',
      participants: 'Participantes',
      pending: 'Pendientes',
      refused: 'Rechazadas',
      total_tips: 'Total de donaciones',
      top_songs: 'Top canciones',
      played_status: 'Reproducida',
      // PRO paywall
      pro_feature: 'Función Pro',
      pro_feature_desc: 'Las estadísticas avanzadas y la gestión de eventos están disponibles en la versión Pro.',
      pro_includes: 'Incluido en Pro:',
      pro_create_events: 'Crear y gestionar eventos',
      pro_detailed_stats: 'Estadísticas detalladas por evento',
      pro_history: 'Historial completo de eventos',
      pro_top_songs: 'Top canciones y analíticas',
      coming_soon: 'Próximamente',
      types: {
        mariage: 'Boda',
        club: 'Club',
        bar: 'Bar',
        anniversaire: 'Cumpleaños',
        entreprise: 'Empresa',
        autre: 'Otro'
      },
      // Event requests view
      event_requests: 'Solicitudes del evento',
      view_requests: 'Ver solicitudes',
      all_requests: 'Todas',
      pending_requests: 'Pendientes',
      played_requests: 'Reproducidas',
      refused_requests: 'Rechazadas',
      search_requests: 'Buscar...',
      sort_by_date: 'Por fecha',
      sort_by_likes: 'Por likes',
      no_requests: 'Sin solicitudes',
      no_requests_hint: 'No hay solicitudes para este evento',
      requested_by: 'Solicitado por',
      request_status: 'Estado'
    },
    de: {
      title: 'Meine Events',
      new_event: 'Neues Event',
      no_events: 'Keine Events erstellt',
      create_first: 'Erstelle dein erstes Event!',
      event_name: 'Event-Name',
      event_type: 'Event-Typ',
      event_date: 'Datum',
      event_location: 'Ort',
      event_guests: 'Anzahl der Gäste',
      status_draft: 'Entwurf',
      status_active: 'Aktiv',
      status_closed: 'Beendet',
      activate: 'Aktivieren (Tag X)',
      close_event: 'Beenden',
      reopen: 'Anfragen wieder öffnen',
      view_details: 'Details anzeigen',
      open_form: 'Kundenformular öffnen',
      copy_link: 'Link kopieren',
      download_qr: 'QR herunterladen',
      download_poster: 'Poster herunterladen',
      music_prefs: 'Musikwünsche',
      authority_label: 'Entscheider',
      authority_banned: 'Verboten',
      authority_loves: 'Wünsche',
      // Additional keys
      global_stats: 'Globale Statistiken',
      events_count: 'Events',
      total_requests: 'Gesamtanfragen',
      played: 'Gespielt',
      donations: 'Spenden',
      pro_reports: 'PRO Berichte',
      download_reports: 'Lade deine detaillierten Berichte im PDF-Format herunter',
      monthly_report: 'Monatsbericht (aktuell)',
      annual_report: 'Jahresbericht (aktuell)',
      custom_report: 'Benutzerdefinierter Bericht',
      start_date: 'Startdatum',
      end_date: 'Enddatum',
      generate: 'Generieren',
      event_in_progress: 'Event läuft',
      live_stats: 'Live Stats',
      close: 'Beenden',
      my_events: 'Meine Events',
      upcoming: 'Kommend',
      closed: 'Beendet',
      no_upcoming: 'Keine kommenden Events',
      no_closed: 'Keine beendeten Events',
      create_first_hint: 'Erstelle dein erstes Event, um loszulegen!',
      requests: 'Anfrage',
      requests_plural: 'Anfragen',
      open: 'Offen',
      closed_status: 'Geschlossen',
      link_copied: 'Link kopiert',
      copy_failed: 'Kopieren fehlgeschlagen',
      copy: 'Kopieren',
      share: 'Teilen',
      poster_a4: 'A4-Poster',
      poster_a5: 'A5-Karten',
      link_unavailable: 'Link nicht verfügbar',
      modify: 'Bearbeiten',
      delete: 'Löschen',
      duration: 'Dauer',
      participants: 'Teilnehmer',
      pending: 'Ausstehend',
      refused: 'Abgelehnt',
      total_tips: 'Gesamtspenden',
      top_songs: 'Top Songs',
      played_status: 'Gespielt',
      // PRO paywall
      pro_feature: 'Pro Funktion',
      pro_feature_desc: 'Erweiterte Statistiken und Event-Verwaltung sind in der Pro-Version verfügbar.',
      pro_includes: 'In Pro enthalten:',
      pro_create_events: 'Events erstellen und verwalten',
      pro_detailed_stats: 'Detaillierte Statistiken pro Event',
      pro_history: 'Vollständige Event-Historie',
      pro_top_songs: 'Top Songs und Analytics',
      coming_soon: 'Demnächst verfügbar',
      types: {
        mariage: 'Hochzeit',
        club: 'Club',
        bar: 'Bar',
        anniversaire: 'Geburtstag',
        entreprise: 'Firmenfeier',
        autre: 'Andere'
      },
      // Event requests view
      event_requests: 'Event-Anfragen',
      view_requests: 'Anfragen anzeigen',
      all_requests: 'Alle',
      pending_requests: 'Ausstehend',
      played_requests: 'Gespielt',
      refused_requests: 'Abgelehnt',
      search_requests: 'Suchen...',
      sort_by_date: 'Nach Datum',
      sort_by_likes: 'Nach Likes',
      no_requests: 'Keine Anfragen',
      no_requests_hint: 'Keine Anfragen für dieses Event',
      requested_by: 'Angefragt von',
      request_status: 'Status'
    },
    pt: {
      title: 'Meus eventos',
      new_event: 'Novo evento',
      no_events: 'Nenhum evento criado',
      create_first: 'Crie seu primeiro evento!',
      event_name: 'Nome do evento',
      event_type: 'Tipo de evento',
      event_date: 'Data',
      event_location: 'Local',
      event_guests: 'Número de convidados',
      status_draft: 'Rascunho',
      status_active: 'Ativo',
      status_closed: 'Encerrado',
      activate: 'Ativar (Dia D)',
      close_event: 'Encerrar',
      reopen: 'Reabrir pedidos',
      view_details: 'Ver detalhes',
      open_form: 'Abrir formulário',
      copy_link: 'Copiar link',
      download_qr: 'Baixar QR',
      download_poster: 'Baixar cartaz',
      music_prefs: 'Preferências musicais',
      authority_label: 'Responsável',
      authority_banned: 'Proibidos',
      authority_loves: 'Desejos',
      // Additional keys
      global_stats: 'Estatísticas globais',
      events_count: 'Eventos',
      total_requests: 'Pedidos totais',
      played: 'Tocadas',
      donations: 'Doações',
      pro_reports: 'Relatórios PRO',
      download_reports: 'Baixe seus relatórios detalhados em formato PDF',
      monthly_report: 'Relatório mensal (atual)',
      annual_report: 'Relatório anual (atual)',
      custom_report: 'Relatório personalizado',
      start_date: 'Data início',
      end_date: 'Data fim',
      generate: 'Gerar',
      event_in_progress: 'Evento em andamento',
      live_stats: 'Stats ao vivo',
      close: 'Encerrar',
      my_events: 'Meus eventos',
      upcoming: 'Próximos',
      closed: 'Encerrados',
      no_upcoming: 'Nenhum evento próximo',
      no_closed: 'Nenhum evento encerrado',
      create_first_hint: 'Crie seu primeiro evento para começar!',
      requests: 'pedido',
      requests_plural: 'pedidos',
      open: 'Aberto',
      closed_status: 'Fechado',
      link_copied: 'Link copiado',
      copy_failed: 'Falha ao copiar',
      copy: 'Copiar',
      share: 'Compartilhar',
      poster_a4: 'Cartaz A4',
      poster_a5: 'Cartões A5',
      link_unavailable: 'Link indisponível',
      modify: 'Editar',
      delete: 'Excluir',
      duration: 'Duração',
      participants: 'Participantes',
      pending: 'Pendentes',
      refused: 'Recusados',
      total_tips: 'Total de doações',
      top_songs: 'Top músicas',
      played_status: 'Tocada',
      // PRO paywall
      pro_feature: 'Recurso Pro',
      pro_feature_desc: 'Estatísticas avançadas e gerenciamento de eventos estão disponíveis na versão Pro.',
      pro_includes: 'Incluído no Pro:',
      pro_create_events: 'Criar e gerenciar eventos',
      pro_detailed_stats: 'Estatísticas detalhadas por evento',
      pro_history: 'Histórico completo de eventos',
      pro_top_songs: 'Top músicas e analytics',
      coming_soon: 'Em breve',
      types: {
        mariage: 'Casamento',
        club: 'Club',
        bar: 'Bar',
        anniversaire: 'Aniversário',
        entreprise: 'Corporativo',
        autre: 'Outro'
      },
      // Event requests view
      event_requests: 'Pedidos do evento',
      view_requests: 'Ver pedidos',
      all_requests: 'Todos',
      pending_requests: 'Pendentes',
      played_requests: 'Tocados',
      refused_requests: 'Recusados',
      search_requests: 'Pesquisar...',
      sort_by_date: 'Por data',
      sort_by_likes: 'Por likes',
      no_requests: 'Sem pedidos',
      no_requests_hint: 'Nenhum pedido para este evento',
      requested_by: 'Pedido por',
      request_status: 'Status'
    }
  },

  // ==================== SETTINGS ====================
  settings: {
    fr: {
      title: 'Paramètres',
      profile: 'Profil',
      subscription: 'Abonnement',
      notifications: 'Notifications',
      account: 'Compte',
      moderation: 'Modération',
      tips: 'Pourboires',
      tips_tab: 'Pourboires',
      dj_name: 'Nom de DJ',
      email: 'Email',
      phone: 'Téléphone',
      city: 'Ville',
      bio: 'Bio',
      social_links: 'Réseaux sociaux',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      facebook: 'Facebook',
      website: 'Site web',
      change_password: 'Changer le mot de passe',
      current_password: 'Mot de passe actuel',
      new_password: 'Nouveau mot de passe',
      delete_account: 'Supprimer mon compte',
      delete_warning: 'Cette action est irréversible',
      save_changes: 'Enregistrer les modifications',
      profile_updated: 'Profil mis à jour !',
      interface_language: 'Langue de l\'interface',
      interface_language_desc: 'Change la langue de l\'application et de tes formulaires clients',
      // Profile tab
      business_card: 'Carte de visite',
      business_card_desc: 'Ces informations seront visibles par vos clients.',
      profile_photo: 'Photo de profil',
      custom_logo: 'Logo personnalisé',
      display_name: 'Nom d\'affichage',
      full_name: 'Nom complet',
      public_email: 'Email public',
      review_url: 'Lien pour laisser un avis',
      review_url_desc: 'Lien Google, Facebook ou autre plateforme pour recueillir des avis',
      additional_info: 'Informations supplémentaires',
      upload: 'Choisir',
      uploading: 'Envoi...',
      delete: 'Supprimer',
      save_profile: 'Enregistrer le profil',
      saving: 'Enregistrement...',
      saved: 'Enregistré',
      profile_saved_success: 'Profil enregistré avec succès',
      profile_saved_error: 'Erreur lors de l\'enregistrement du profil',
      settings_saved_success: 'Paramètres enregistrés avec succès',
      settings_saved_error: 'Erreur lors de l\'enregistrement',
      file_too_large: 'Fichier trop volumineux. Taille max: 3MB',
      file_type_error: 'Type de fichier non autorisé. Types acceptés: PNG, JPG, WEBP',
      // Tips tab
      tips_options: 'Options de pourboire',
      tips_desc: 'Configurez vos moyens de paiement pour recevoir des pourboires.',
      paypal_name: 'Nom PayPal.me',
      wero_number: 'Numéro Wero',
      save_tips: 'Enregistrer les pourboires',
      // Moderation tab
      forbidden_words: 'Mots interdits',
      forbidden_words_desc: 'Les messages contenant ces mots seront automatiquement censurés.',
      add_word: 'Ajouter un mot...',
      blocked_clients: 'Clients bloqués',
      blocked_clients_desc: 'Ces clients ne peuvent plus envoyer de demandes.',
      no_blocked: 'Aucun client bloqué',
      unblock: 'Débloquer',
      // Subscription tab
      subscription_title: 'Abonnement TrackVibes',
      subscription_desc: 'Gère ton abonnement et accède aux fonctionnalités PRO',
      current_plan: 'Plan actuel',
      founder: 'FONDATEUR',
      trial: 'Essai',
      lifetime_rate: 'à vie',
      cancel_scheduled: 'Annulation prévue',
      payment_overdue: 'Paiement en retard',
      next_billing: 'Prochaine facture',
      trial_ends: 'Fin de l\'essai gratuit',
      subscription_ends: 'Fin de l\'abonnement',
      founder_offer: 'Offre Fondateur : les 100 premiers DJs bénéficient du tarif 4,99€/mois à vie.',
      upgrade_cta: 'Passe à TrackVibes Pro',
      unlock_features: 'Débloque toutes les fonctionnalités :',
      event_qr: 'QR code événement',
      integrated_tips: 'Pourboires intégrés (PayPal)',
      advanced_stats: 'Statistiques avancées',
      pdf_export: 'Export PDF mensuel et annuel',
      dj_card: 'Carte de visite DJ',
      free_trial: '14 jours d\'essai gratuit',
      cancel_anytime: 'Annulation à tout moment',
      start_trial: 'Commencer mon essai gratuit',
      subscribe: 'S\'abonner à PRO',
      manage_subscription: 'Gérer mon abonnement',
      manage_hint: 'Modifie ou annule ton abonnement via le portail Stripe',
      secure_payment: 'Paiement sécurisé par Stripe. Annulation possible à tout moment.',
      pro_advantages: 'Avantages PRO',
      unlimited_events: 'Gestion d\'événements illimitée',
      custom_qr: 'QR codes personnalisés par événement',
      stats_reports: 'Statistiques avancées et rapports PDF',
      popularity_sort: 'Tri des demandes par popularité',
      hot_badge: 'Badge \'Très soutenu\' sur les hits',
      priority_support: 'Support prioritaire',
      // Lifetime section
      lifetime_title: 'Lifetime Gold',
      lifetime_badge: 'Utilisateur Lifetime',
      lifetime_desc: 'Vous bénéficiez de l\'usage PRO de TrackVibes à vie.',
      lifetime_thanks: 'Merci pour votre confiance ! Vous avez un accès illimité et permanent à toutes les fonctionnalités PRO.',
      lifetime_advantages: 'Vos avantages Lifetime',
      no_subscription: 'Aucun abonnement à gérer',
      // Delete account
      delete_account_title: 'Supprimer définitivement mon compte',
      delete_account_warning: 'Toutes vos données (événements, statistiques, QR codes, profil) seront supprimées définitivement.',
      active_sub_warning: 'Vous avez un abonnement Pro actif. Merci d\'annuler votre abonnement depuis votre espace Stripe avant de supprimer votre compte.',
      delete_confirm: 'Supprimer mon compte définitivement',
      // Support section
      support_title: 'Support & Contact',
      support_question: 'Besoin d\'aide ou envie d\'améliorer TrackVibes ?',
      support_desc: 'Une suggestion ? Un bug ? Une idée pour améliorer l\'expérience DJ ? Contactez-nous directement.',
      contact_support: 'Contacter le support',
      // Footer
      whats_new: 'Voir les nouveautés',
      privacy: 'Confidentialité',
      terms: 'CGU',
      legal: 'Mentions légales',
      contact: 'Contact'
    },
    en: {
      title: 'Settings',
      profile: 'Profile',
      subscription: 'Subscription',
      notifications: 'Notifications',
      account: 'Account',
      moderation: 'Moderation',
      tips: 'Tips',
      tips_tab: 'Tips',
      dj_name: 'DJ Name',
      email: 'Email',
      phone: 'Phone',
      city: 'City',
      bio: 'Bio',
      social_links: 'Social links',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      facebook: 'Facebook',
      website: 'Website',
      change_password: 'Change password',
      current_password: 'Current password',
      new_password: 'New password',
      delete_account: 'Delete my account',
      delete_warning: 'This action is irreversible',
      save_changes: 'Save changes',
      profile_updated: 'Profile updated!',
      interface_language: 'Interface language',
      interface_language_desc: 'Change the language of the app and your client forms',
      // Profile tab
      business_card: 'Business card',
      business_card_desc: 'This information will be visible to your clients.',
      profile_photo: 'Profile photo',
      custom_logo: 'Custom logo',
      display_name: 'Display name',
      full_name: 'Full name',
      public_email: 'Public email',
      review_url: 'Review link',
      review_url_desc: 'Google, Facebook or other platform link to collect reviews',
      additional_info: 'Additional information',
      upload: 'Upload',
      uploading: 'Uploading...',
      delete: 'Delete',
      save_profile: 'Save profile',
      saving: 'Saving...',
      saved: 'Saved',
      profile_saved_success: 'Profile saved successfully',
      profile_saved_error: 'Error saving profile',
      settings_saved_success: 'Settings saved successfully',
      settings_saved_error: 'Error saving settings',
      file_too_large: 'File too large. Max size: 3MB',
      file_type_error: 'File type not allowed. Allowed types: PNG, JPG, WEBP',
      // Tips tab
      tips_options: 'Tip options',
      tips_desc: 'Configure your payment methods to receive tips.',
      paypal_name: 'PayPal.me name',
      wero_number: 'Wero number',
      save_tips: 'Save tips',
      // Moderation tab
      forbidden_words: 'Forbidden words',
      forbidden_words_desc: 'Messages containing these words will be automatically censored.',
      add_word: 'Add a word...',
      blocked_clients: 'Blocked clients',
      blocked_clients_desc: 'These clients can no longer send requests.',
      no_blocked: 'No blocked clients',
      unblock: 'Unblock',
      // Subscription tab
      subscription_title: 'TrackVibes Subscription',
      subscription_desc: 'Manage your subscription and access PRO features',
      current_plan: 'Current plan',
      founder: 'FOUNDER',
      trial: 'Trial',
      lifetime_rate: 'for life',
      cancel_scheduled: 'Cancellation scheduled',
      payment_overdue: 'Payment overdue',
      next_billing: 'Next billing',
      trial_ends: 'Free trial ends',
      subscription_ends: 'Subscription ends',
      founder_offer: 'Founder Offer: the first 100 DJs get the €4.99/month rate for life.',
      upgrade_cta: 'Upgrade to TrackVibes Pro',
      unlock_features: 'Unlock all features:',
      event_qr: 'Event QR code',
      integrated_tips: 'Integrated tips (PayPal)',
      advanced_stats: 'Advanced statistics',
      pdf_export: 'Monthly and annual PDF export',
      dj_card: 'DJ business card',
      free_trial: '14-day free trial',
      cancel_anytime: 'Cancel anytime',
      start_trial: 'Start my free trial',
      subscribe: 'Subscribe to PRO',
      manage_subscription: 'Manage my subscription',
      manage_hint: 'Modify or cancel your subscription via the Stripe portal',
      secure_payment: 'Secure payment by Stripe. Cancel anytime.',
      pro_advantages: 'PRO Advantages',
      unlimited_events: 'Unlimited event management',
      custom_qr: 'Custom QR codes per event',
      stats_reports: 'Advanced statistics and PDF reports',
      popularity_sort: 'Sort requests by popularity',
      hot_badge: '\'Very supported\' badge on hits',
      priority_support: 'Priority support',
      // Lifetime section
      lifetime_title: 'Lifetime Gold',
      lifetime_badge: 'Lifetime User',
      lifetime_desc: 'You have lifetime PRO access to TrackVibes.',
      lifetime_thanks: 'Thank you for your trust! You have unlimited and permanent access to all PRO features.',
      lifetime_advantages: 'Your Lifetime advantages',
      no_subscription: 'No subscription to manage',
      // Delete account
      delete_account_title: 'Permanently delete my account',
      delete_account_warning: 'All your data (events, statistics, QR codes, profile) will be permanently deleted.',
      active_sub_warning: 'You have an active Pro subscription. Please cancel your subscription via Stripe before deleting your account.',
      delete_confirm: 'Delete my account permanently',
      // Support section
      support_title: 'Support & Contact',
      support_question: 'Need help or want to improve TrackVibes?',
      support_desc: 'A suggestion? A bug? An idea to improve the DJ experience? Contact us directly.',
      contact_support: 'Contact support',
      // Footer
      whats_new: 'See what\'s new',
      privacy: 'Privacy',
      terms: 'Terms',
      legal: 'Legal',
      contact: 'Contact'
    },
    es: {
      title: 'Configuración',
      profile: 'Perfil',
      subscription: 'Suscripción',
      notifications: 'Notificaciones',
      account: 'Cuenta',
      moderation: 'Moderación',
      tips: 'Propinas',
      tips_tab: 'Propinas',
      dj_name: 'Nombre de DJ',
      email: 'Email',
      phone: 'Teléfono',
      city: 'Ciudad',
      bio: 'Bio',
      social_links: 'Redes sociales',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      facebook: 'Facebook',
      website: 'Sitio web',
      change_password: 'Cambiar contraseña',
      current_password: 'Contraseña actual',
      new_password: 'Nueva contraseña',
      delete_account: 'Eliminar mi cuenta',
      delete_warning: 'Esta acción es irreversible',
      save_changes: 'Guardar cambios',
      profile_updated: '¡Perfil actualizado!',
      interface_language: 'Idioma de la interfaz',
      interface_language_desc: 'Cambia el idioma de la app y tus formularios',
      // Profile tab
      business_card: 'Tarjeta de presentación',
      business_card_desc: 'Esta información será visible para tus clientes.',
      profile_photo: 'Foto de perfil',
      custom_logo: 'Logo personalizado',
      display_name: 'Nombre para mostrar',
      full_name: 'Nombre completo',
      public_email: 'Email público',
      review_url: 'Enlace para dejar opinión',
      review_url_desc: 'Enlace de Google, Facebook u otra plataforma para recoger opiniones',
      additional_info: 'Información adicional',
      upload: 'Subir',
      uploading: 'Subiendo...',
      delete: 'Eliminar',
      save_profile: 'Guardar perfil',
      saving: 'Guardando...',
      saved: 'Guardado',
      profile_saved_success: 'Perfil guardado con éxito',
      profile_saved_error: 'Error al guardar el perfil',
      settings_saved_success: 'Configuración guardada con éxito',
      settings_saved_error: 'Error al guardar la configuración',
      file_too_large: 'Archivo demasiado grande. Tamaño máximo: 3MB',
      file_type_error: 'Tipo de archivo no permitido. Tipos aceptados: PNG, JPG, WEBP',
      // Tips tab
      tips_options: 'Opciones de propina',
      tips_desc: 'Configura tus métodos de pago para recibir propinas.',
      paypal_name: 'Nombre PayPal.me',
      wero_number: 'Número Wero',
      save_tips: 'Guardar propinas',
      // Moderation tab
      forbidden_words: 'Palabras prohibidas',
      forbidden_words_desc: 'Los mensajes que contengan estas palabras serán censurados automáticamente.',
      add_word: 'Añadir una palabra...',
      blocked_clients: 'Clientes bloqueados',
      blocked_clients_desc: 'Estos clientes ya no pueden enviar solicitudes.',
      no_blocked: 'Ningún cliente bloqueado',
      unblock: 'Desbloquear',
      // Subscription tab
      subscription_title: 'Suscripción TrackVibes',
      subscription_desc: 'Gestiona tu suscripción y accede a las funciones PRO',
      current_plan: 'Plan actual',
      founder: 'FUNDADOR',
      trial: 'Prueba',
      lifetime_rate: 'de por vida',
      cancel_scheduled: 'Cancelación programada',
      payment_overdue: 'Pago atrasado',
      next_billing: 'Próxima facturación',
      trial_ends: 'Fin de la prueba gratuita',
      subscription_ends: 'Fin de la suscripción',
      founder_offer: 'Oferta Fundador: los primeros 100 DJs obtienen la tarifa de 4,99€/mes de por vida.',
      upgrade_cta: 'Pasa a TrackVibes Pro',
      unlock_features: 'Desbloquea todas las funciones:',
      event_qr: 'Código QR de evento',
      integrated_tips: 'Propinas integradas (PayPal)',
      advanced_stats: 'Estadísticas avanzadas',
      pdf_export: 'Exportación PDF mensual y anual',
      dj_card: 'Tarjeta de presentación DJ',
      free_trial: '14 días de prueba gratis',
      cancel_anytime: 'Cancela cuando quieras',
      start_trial: 'Comenzar mi prueba gratis',
      subscribe: 'Suscribirse a PRO',
      manage_subscription: 'Gestionar mi suscripción',
      manage_hint: 'Modifica o cancela tu suscripción a través del portal de Stripe',
      secure_payment: 'Pago seguro por Stripe. Cancela cuando quieras.',
      pro_advantages: 'Ventajas PRO',
      unlimited_events: 'Gestión de eventos ilimitada',
      custom_qr: 'Códigos QR personalizados por evento',
      stats_reports: 'Estadísticas avanzadas e informes PDF',
      popularity_sort: 'Ordenar solicitudes por popularidad',
      hot_badge: 'Insignia \'Muy apoyado\' en los éxitos',
      priority_support: 'Soporte prioritario',
      // Lifetime section
      lifetime_title: 'Lifetime Gold',
      lifetime_badge: 'Usuario Lifetime',
      lifetime_desc: 'Tienes acceso PRO de por vida a TrackVibes.',
      lifetime_thanks: '¡Gracias por tu confianza! Tienes acceso ilimitado y permanente a todas las funciones PRO.',
      lifetime_advantages: 'Tus ventajas Lifetime',
      no_subscription: 'Sin suscripción que gestionar',
      // Delete account
      delete_account_title: 'Eliminar mi cuenta permanentemente',
      delete_account_warning: 'Todos tus datos (eventos, estadísticas, códigos QR, perfil) serán eliminados permanentemente.',
      active_sub_warning: 'Tienes una suscripción Pro activa. Cancela tu suscripción a través de Stripe antes de eliminar tu cuenta.',
      delete_confirm: 'Eliminar mi cuenta permanentemente',
      // Support section
      support_title: 'Soporte y Contacto',
      support_question: '¿Necesitas ayuda o quieres mejorar TrackVibes?',
      support_desc: '¿Una sugerencia? ¿Un error? ¿Una idea para mejorar la experiencia DJ? Contáctanos directamente.',
      contact_support: 'Contactar soporte',
      // Footer
      whats_new: 'Ver novedades',
      privacy: 'Privacidad',
      terms: 'Términos',
      legal: 'Legal',
      contact: 'Contacto'
    },
    de: {
      title: 'Einstellungen',
      profile: 'Profil',
      subscription: 'Abonnement',
      notifications: 'Benachrichtigungen',
      account: 'Konto',
      moderation: 'Moderation',
      tips: 'Trinkgelder',
      tips_tab: 'Trinkgelder',
      dj_name: 'DJ-Name',
      email: 'E-Mail',
      phone: 'Telefon',
      city: 'Stadt',
      bio: 'Bio',
      social_links: 'Soziale Netzwerke',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      facebook: 'Facebook',
      website: 'Webseite',
      change_password: 'Passwort ändern',
      current_password: 'Aktuelles Passwort',
      new_password: 'Neues Passwort',
      delete_account: 'Mein Konto löschen',
      delete_warning: 'Diese Aktion ist unwiderruflich',
      save_changes: 'Änderungen speichern',
      profile_updated: 'Profil aktualisiert!',
      interface_language: 'Sprache der Oberfläche',
      interface_language_desc: 'Ändere die Sprache der App und deiner Formulare',
      // Profile tab
      business_card: 'Visitenkarte',
      business_card_desc: 'Diese Informationen sind für deine Kunden sichtbar.',
      profile_photo: 'Profilfoto',
      custom_logo: 'Eigenes Logo',
      display_name: 'Anzeigename',
      full_name: 'Vollständiger Name',
      public_email: 'Öffentliche E-Mail',
      review_url: 'Bewertungs-Link',
      review_url_desc: 'Google, Facebook oder andere Plattform-Link für Bewertungen',
      additional_info: 'Zusätzliche Informationen',
      upload: 'Hochladen',
      uploading: 'Hochladen...',
      delete: 'Löschen',
      save_profile: 'Profil speichern',
      saving: 'Speichern...',
      saved: 'Gespeichert',
      profile_saved_success: 'Profil erfolgreich gespeichert',
      profile_saved_error: 'Fehler beim Speichern des Profils',
      settings_saved_success: 'Einstellungen erfolgreich gespeichert',
      settings_saved_error: 'Fehler beim Speichern der Einstellungen',
      file_too_large: 'Datei zu groß. Maximale Größe: 3MB',
      file_type_error: 'Dateityp nicht erlaubt. Erlaubte Typen: PNG, JPG, WEBP',
      // Tips tab
      tips_options: 'Trinkgeld-Optionen',
      tips_desc: 'Konfiguriere deine Zahlungsmethoden für Trinkgelder.',
      paypal_name: 'PayPal.me Name',
      wero_number: 'Wero Nummer',
      save_tips: 'Trinkgelder speichern',
      // Moderation tab
      forbidden_words: 'Verbotene Wörter',
      forbidden_words_desc: 'Nachrichten mit diesen Wörtern werden automatisch zensiert.',
      add_word: 'Wort hinzufügen...',
      blocked_clients: 'Blockierte Kunden',
      blocked_clients_desc: 'Diese Kunden können keine Anfragen mehr senden.',
      no_blocked: 'Keine blockierten Kunden',
      unblock: 'Freigeben',
      // Subscription tab
      subscription_title: 'TrackVibes Abonnement',
      subscription_desc: 'Verwalte dein Abonnement und nutze PRO-Funktionen',
      current_plan: 'Aktueller Plan',
      founder: 'GRÜNDER',
      trial: 'Testphase',
      lifetime_rate: 'lebenslang',
      cancel_scheduled: 'Kündigung geplant',
      payment_overdue: 'Zahlung überfällig',
      next_billing: 'Nächste Rechnung',
      trial_ends: 'Testphase endet',
      subscription_ends: 'Abonnement endet',
      founder_offer: 'Gründerangebot: Die ersten 100 DJs erhalten den Tarif von 4,99€/Monat lebenslang.',
      upgrade_cta: 'Wechsel zu TrackVibes Pro',
      unlock_features: 'Alle Funktionen freischalten:',
      event_qr: 'Event QR-Code',
      integrated_tips: 'Integrierte Trinkgelder (PayPal)',
      advanced_stats: 'Erweiterte Statistiken',
      pdf_export: 'Monatlicher und jährlicher PDF-Export',
      dj_card: 'DJ Visitenkarte',
      free_trial: '14 Tage kostenlos testen',
      cancel_anytime: 'Jederzeit kündbar',
      start_trial: 'Meine kostenlose Testphase starten',
      subscribe: 'PRO abonnieren',
      manage_subscription: 'Mein Abonnement verwalten',
      manage_hint: 'Ändere oder kündige dein Abonnement über das Stripe-Portal',
      secure_payment: 'Sichere Zahlung über Stripe. Jederzeit kündbar.',
      pro_advantages: 'PRO Vorteile',
      unlimited_events: 'Unbegrenzte Event-Verwaltung',
      custom_qr: 'Individuelle QR-Codes pro Event',
      stats_reports: 'Erweiterte Statistiken und PDF-Berichte',
      popularity_sort: 'Anfragen nach Beliebtheit sortieren',
      hot_badge: '\'Sehr unterstützt\' Badge auf Hits',
      priority_support: 'Prioritäts-Support',
      // Lifetime section
      lifetime_title: 'Lifetime Gold',
      lifetime_badge: 'Lifetime Nutzer',
      lifetime_desc: 'Du hast lebenslangen PRO-Zugang zu TrackVibes.',
      lifetime_thanks: 'Danke für dein Vertrauen! Du hast unbegrenzten und dauerhaften Zugang zu allen PRO-Funktionen.',
      lifetime_advantages: 'Deine Lifetime Vorteile',
      no_subscription: 'Kein Abonnement zu verwalten',
      // Delete account
      delete_account_title: 'Mein Konto dauerhaft löschen',
      delete_account_warning: 'Alle deine Daten (Events, Statistiken, QR-Codes, Profil) werden dauerhaft gelöscht.',
      active_sub_warning: 'Du hast ein aktives Pro-Abonnement. Bitte kündige dein Abonnement über Stripe, bevor du dein Konto löschst.',
      delete_confirm: 'Mein Konto dauerhaft löschen',
      // Support section
      support_title: 'Support & Kontakt',
      support_question: 'Brauchst du Hilfe oder möchtest TrackVibes verbessern?',
      support_desc: 'Ein Vorschlag? Ein Fehler? Eine Idee zur Verbesserung des DJ-Erlebnisses? Kontaktiere uns direkt.',
      contact_support: 'Support kontaktieren',
      // Footer
      whats_new: 'Neuigkeiten ansehen',
      privacy: 'Datenschutz',
      terms: 'AGB',
      legal: 'Impressum',
      contact: 'Kontakt'
    },
    pt: {
      title: 'Configurações',
      profile: 'Perfil',
      subscription: 'Assinatura',
      notifications: 'Notificações',
      account: 'Conta',
      moderation: 'Moderação',
      tips: 'Gorjetas',
      tips_tab: 'Gorjetas',
      dj_name: 'Nome de DJ',
      email: 'Email',
      phone: 'Telefone',
      city: 'Cidade',
      bio: 'Bio',
      social_links: 'Redes sociais',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      facebook: 'Facebook',
      website: 'Site',
      change_password: 'Alterar senha',
      current_password: 'Senha atual',
      new_password: 'Nova senha',
      delete_account: 'Excluir minha conta',
      delete_warning: 'Esta ação é irreversível',
      save_changes: 'Salvar alterações',
      profile_updated: 'Perfil atualizado!',
      interface_language: 'Idioma da interface',
      interface_language_desc: 'Altere o idioma do app e seus formulários',
      // Profile tab
      business_card: 'Cartão de visita',
      business_card_desc: 'Essas informações serão visíveis para seus clientes.',
      profile_photo: 'Foto de perfil',
      custom_logo: 'Logo personalizado',
      display_name: 'Nome de exibição',
      full_name: 'Nome completo',
      public_email: 'Email público',
      review_url: 'Link para deixar avaliação',
      review_url_desc: 'Link do Google, Facebook ou outra plataforma para coletar avaliações',
      additional_info: 'Informações adicionais',
      upload: 'Enviar',
      uploading: 'Enviando...',
      delete: 'Excluir',
      save_profile: 'Salvar perfil',
      saving: 'Salvando...',
      saved: 'Salvo',
      profile_saved_success: 'Perfil salvo com sucesso',
      profile_saved_error: 'Erro ao salvar perfil',
      settings_saved_success: 'Configurações salvas com sucesso',
      settings_saved_error: 'Erro ao salvar configurações',
      file_too_large: 'Arquivo muito grande. Tamanho máximo: 3MB',
      file_type_error: 'Tipo de arquivo não permitido. Tipos aceitos: PNG, JPG, WEBP',
      // Tips tab
      tips_options: 'Opções de gorjeta',
      tips_desc: 'Configure seus métodos de pagamento para receber gorjetas.',
      paypal_name: 'Nome PayPal.me',
      wero_number: 'Número Wero',
      save_tips: 'Salvar gorjetas',
      // Moderation tab
      forbidden_words: 'Palavras proibidas',
      forbidden_words_desc: 'Mensagens contendo essas palavras serão automaticamente censuradas.',
      add_word: 'Adicionar uma palavra...',
      blocked_clients: 'Clientes bloqueados',
      blocked_clients_desc: 'Esses clientes não podem mais enviar pedidos.',
      no_blocked: 'Nenhum cliente bloqueado',
      unblock: 'Desbloquear',
      // Subscription tab
      subscription_title: 'Assinatura TrackVibes',
      subscription_desc: 'Gerencie sua assinatura e acesse os recursos PRO',
      current_plan: 'Plano atual',
      founder: 'FUNDADOR',
      trial: 'Teste',
      lifetime_rate: 'para sempre',
      cancel_scheduled: 'Cancelamento agendado',
      payment_overdue: 'Pagamento atrasado',
      next_billing: 'Próxima cobrança',
      trial_ends: 'Fim do teste grátis',
      subscription_ends: 'Fim da assinatura',
      founder_offer: 'Oferta Fundador: os primeiros 100 DJs têm a tarifa de 4,99€/mês para sempre.',
      upgrade_cta: 'Mude para TrackVibes Pro',
      unlock_features: 'Desbloqueie todos os recursos:',
      event_qr: 'QR code de evento',
      integrated_tips: 'Gorjetas integradas (PayPal)',
      advanced_stats: 'Estatísticas avançadas',
      pdf_export: 'Exportação PDF mensal e anual',
      dj_card: 'Cartão de visita DJ',
      free_trial: '14 dias de teste grátis',
      cancel_anytime: 'Cancele a qualquer momento',
      start_trial: 'Começar meu teste grátis',
      subscribe: 'Assinar PRO',
      manage_subscription: 'Gerenciar minha assinatura',
      manage_hint: 'Modifique ou cancele sua assinatura pelo portal Stripe',
      secure_payment: 'Pagamento seguro pelo Stripe. Cancele a qualquer momento.',
      pro_advantages: 'Vantagens PRO',
      unlimited_events: 'Gerenciamento de eventos ilimitado',
      custom_qr: 'QR codes personalizados por evento',
      stats_reports: 'Estatísticas avançadas e relatórios PDF',
      popularity_sort: 'Ordenar pedidos por popularidade',
      hot_badge: 'Distintivo \'Muito apoiado\' nos hits',
      priority_support: 'Suporte prioritário',
      // Lifetime section
      lifetime_title: 'Lifetime Gold',
      lifetime_badge: 'Usuário Lifetime',
      lifetime_desc: 'Você tem acesso PRO vitalício ao TrackVibes.',
      lifetime_thanks: 'Obrigado pela sua confiança! Você tem acesso ilimitado e permanente a todos os recursos PRO.',
      lifetime_advantages: 'Suas vantagens Lifetime',
      no_subscription: 'Sem assinatura para gerenciar',
      // Delete account
      delete_account_title: 'Excluir minha conta permanentemente',
      delete_account_warning: 'Todos os seus dados (eventos, estatísticas, QR codes, perfil) serão excluídos permanentemente.',
      active_sub_warning: 'Você tem uma assinatura Pro ativa. Cancele sua assinatura pelo Stripe antes de excluir sua conta.',
      delete_confirm: 'Excluir minha conta permanentemente',
      // Support section
      support_title: 'Suporte e Contato',
      support_question: 'Precisa de ajuda ou quer melhorar o TrackVibes?',
      support_desc: 'Uma sugestão? Um bug? Uma ideia para melhorar a experiência DJ? Entre em contato diretamente.',
      contact_support: 'Contatar suporte',
      // Footer
      whats_new: 'Ver novidades',
      privacy: 'Privacidade',
      terms: 'Termos',
      legal: 'Legal',
      contact: 'Contato'
    }
  },

  // ==================== QR CODES ====================
  qrcodes: {
    fr: {
      title: 'Mes QR Codes',
      permanent_qr: 'QR Codes permanents',
      event_qr: 'QR Codes événements',
      free_mode: 'Mode Gratuit',
      free_desc: 'QR code universel pour collecter des demandes',
      pro_mode: 'Mode Pro',
      pro_desc: 'Parfait pour les soirées privées et mariages',
      no_events: 'Aucun événement avec QR code',
      create_event: 'Crée un événement pour générer un QR code dédié',
      open_form: 'Ouvrir le formulaire client',
      download_a4: 'Affiche A4',
      download_a5: 'Cartes A5',
      back: 'Retour',
      choose_qr: 'Choisis le QR code adapté à ta soirée',
      your_qr: 'Ton QR code pour recevoir des demandes',
      plan_free: 'Plan FREE',
      plan_pro: 'Plan PRO',
      qr_free_title: 'QR Code – Version Free',
      qr_pro_title: 'QR Code – Version Pro',
      included: 'Inclus :',
      standard_form: 'Formulaire de demande standard',
      realtime_list: 'Liste des demandes en temps réel',
      multi_lang: 'Multi-langues (FR/EN/ES/DE)',
      copy_link: 'Copier le lien',
      link_copied: 'Lien copié !',
      download_error: 'Erreur lors du téléchargement',
      pro_features: 'Fonctionnalités Pro',
      tips_enabled: 'Pourboires activés',
      event_stats: 'Stats par événement',
      custom_branding: 'Branding personnalisé',
      event_qrcodes: 'QR Codes par événement',
      no_event_qr: 'Aucun événement avec QR code',
      create_event_hint: 'Crée un événement PRO pour générer un QR code dédié',
      // Additional keys
      recommended: 'RECOMMANDÉ',
      all_free_plan: 'Tout le plan Free',
      dj_business_card: 'Carte de visite DJ',
      tip_option: 'Option de don (PayPal/Wero)',
      detailed_stats: 'Statistiques détaillées',
      unique_event_qr: 'QR codes uniques pour événements',
      copied: 'Copié',
      // Pro locked section
      pro_version: 'Version Pro',
      unlock_pro: 'Débloquez les QR codes événements, les statistiques avancées et la carte de visite DJ avec TrackVibes Pro.',
      upgrade_pro: 'Passer en version Pro',
      trial_info: '14 jours gratuits – Annulation à tout moment',
      // Event QR section
      event_qr_title: 'QR Codes Événements',
      manage_events: 'Gérer les événements',
      no_event_qr_hint: 'Crée un événement pour obtenir un QR code unique et collecter des demandes en amont',
      create_event_btn: 'Créer un événement',
      active: 'En cours',
      draft: 'Brouillon',
      requests_count: 'demande',
      requests_count_plural: 'demandes',
      // Info box
      advance_collection: 'Collecte en amont',
      advance_collection_desc: 'Partagez le QR code d\'un événement avant le jour J. Les invités peuvent envoyer leurs demandes à l\'avance. Le jour J, activez l\'événement pour voir toutes les demandes dans votre dashboard.',
      // Tips section
      usage_tips: 'Conseils d\'utilisation',
      free_tip: 'Idéal pour tous types de soirées',
      pro_tip: 'Parfait pour les soirées privées et mariages',
      print_tip: 'Imprimez le QR code et affichez-le près de votre cabine'
    },
    en: {
      title: 'My QR Codes',
      permanent_qr: 'Permanent QR Codes',
      event_qr: 'Event QR Codes',
      free_mode: 'Free Mode',
      free_desc: 'Universal QR code to collect requests',
      pro_mode: 'Pro Mode',
      pro_desc: 'Perfect for private parties and weddings',
      no_events: 'No events with QR code',
      create_event: 'Create an event to generate a dedicated QR code',
      open_form: 'Open client form',
      download_a4: 'A4 Poster',
      download_a5: 'A5 Cards',
      back: 'Back',
      choose_qr: 'Choose the QR code for your party',
      your_qr: 'Your QR code to receive requests',
      plan_free: 'FREE Plan',
      plan_pro: 'PRO Plan',
      qr_free_title: 'QR Code – Free Version',
      qr_pro_title: 'QR Code – Pro Version',
      included: 'Included:',
      standard_form: 'Standard request form',
      realtime_list: 'Real-time request list',
      multi_lang: 'Multi-language (FR/EN/ES/DE)',
      copy_link: 'Copy link',
      link_copied: 'Link copied!',
      download_error: 'Download error',
      pro_features: 'Pro Features',
      tips_enabled: 'Tips enabled',
      event_stats: 'Event statistics',
      custom_branding: 'Custom branding',
      event_qrcodes: 'Event QR Codes',
      no_event_qr: 'No events with QR code',
      create_event_hint: 'Create a PRO event to generate a dedicated QR code',
      // Additional keys
      recommended: 'RECOMMENDED',
      all_free_plan: 'Everything in Free plan',
      dj_business_card: 'DJ business card',
      tip_option: 'Tip option (PayPal/Wero)',
      detailed_stats: 'Detailed statistics',
      unique_event_qr: 'Unique QR codes for events',
      copied: 'Copied',
      // Pro locked section
      pro_version: 'Pro Version',
      unlock_pro: 'Unlock event QR codes, advanced statistics and DJ business card with TrackVibes Pro.',
      upgrade_pro: 'Upgrade to Pro',
      trial_info: '14-day free trial – Cancel anytime',
      // Event QR section
      event_qr_title: 'Event QR Codes',
      manage_events: 'Manage events',
      no_event_qr_hint: 'Create an event to get a unique QR code and collect requests in advance',
      create_event_btn: 'Create event',
      active: 'Active',
      draft: 'Draft',
      requests_count: 'request',
      requests_count_plural: 'requests',
      // Info box
      advance_collection: 'Advance collection',
      advance_collection_desc: 'Share an event\'s QR code before D-Day. Guests can send requests in advance. On D-Day, activate the event to see all requests in your dashboard.',
      // Tips section
      usage_tips: 'Usage tips',
      free_tip: 'Great for all types of parties',
      pro_tip: 'Perfect for private parties and weddings',
      print_tip: 'Print the QR code and display it near your booth'
    },
    es: {
      title: 'Mis códigos QR',
      permanent_qr: 'Códigos QR permanentes',
      event_qr: 'Códigos QR de eventos',
      free_mode: 'Modo gratuito',
      free_desc: 'Código QR universal para recoger solicitudes',
      pro_mode: 'Modo Pro',
      pro_desc: 'Perfecto para fiestas privadas y bodas',
      no_events: 'Sin eventos con código QR',
      create_event: 'Crea un evento para generar un código QR dedicado',
      open_form: 'Abrir formulario',
      download_a4: 'Cartel A4',
      download_a5: 'Tarjetas A5',
      back: 'Volver',
      choose_qr: 'Elige el código QR para tu fiesta',
      your_qr: 'Tu código QR para recibir solicitudes',
      plan_free: 'Plan GRATIS',
      plan_pro: 'Plan PRO',
      qr_free_title: 'Código QR – Versión Gratis',
      qr_pro_title: 'Código QR – Versión Pro',
      included: 'Incluido:',
      standard_form: 'Formulario de solicitud estándar',
      realtime_list: 'Lista de solicitudes en tiempo real',
      multi_lang: 'Multi-idioma (FR/EN/ES/DE)',
      copy_link: 'Copiar enlace',
      link_copied: '¡Enlace copiado!',
      download_error: 'Error al descargar',
      pro_features: 'Funciones Pro',
      tips_enabled: 'Propinas activadas',
      event_stats: 'Estadísticas de eventos',
      custom_branding: 'Marca personalizada',
      event_qrcodes: 'Códigos QR por evento',
      no_event_qr: 'Sin eventos con código QR',
      create_event_hint: 'Crea un evento PRO para generar un código QR dedicado',
      // Additional keys
      recommended: 'RECOMENDADO',
      all_free_plan: 'Todo del plan Gratis',
      dj_business_card: 'Tarjeta de presentación DJ',
      tip_option: 'Opción de propina (PayPal/Wero)',
      detailed_stats: 'Estadísticas detalladas',
      unique_event_qr: 'Códigos QR únicos para eventos',
      copied: 'Copiado',
      // Pro locked section
      pro_version: 'Versión Pro',
      unlock_pro: 'Desbloquea códigos QR de eventos, estadísticas avanzadas y tarjeta de presentación DJ con TrackVibes Pro.',
      upgrade_pro: 'Pasar a Pro',
      trial_info: '14 días gratis – Cancela cuando quieras',
      // Event QR section
      event_qr_title: 'Códigos QR de Eventos',
      manage_events: 'Gestionar eventos',
      no_event_qr_hint: 'Crea un evento para obtener un código QR único y recoger solicitudes por adelantado',
      create_event_btn: 'Crear evento',
      active: 'Activo',
      draft: 'Borrador',
      requests_count: 'solicitud',
      requests_count_plural: 'solicitudes',
      // Info box
      advance_collection: 'Recolección anticipada',
      advance_collection_desc: 'Comparte el código QR de un evento antes del día D. Los invitados pueden enviar solicitudes por adelantado. El día D, activa el evento para ver todas las solicitudes en tu panel.',
      // Tips section
      usage_tips: 'Consejos de uso',
      free_tip: 'Ideal para todo tipo de fiestas',
      pro_tip: 'Perfecto para fiestas privadas y bodas',
      print_tip: 'Imprime el código QR y colócalo cerca de tu cabina'
    },
    de: {
      title: 'Meine QR-Codes',
      permanent_qr: 'Permanente QR-Codes',
      event_qr: 'Event QR-Codes',
      free_mode: 'Kostenloser Modus',
      free_desc: 'Universeller QR-Code zum Sammeln von Anfragen',
      pro_mode: 'Pro-Modus',
      pro_desc: 'Perfekt für private Feiern und Hochzeiten',
      no_events: 'Keine Events mit QR-Code',
      create_event: 'Erstelle ein Event, um einen dedizierten QR-Code zu generieren',
      open_form: 'Formular öffnen',
      download_a4: 'A4-Poster',
      download_a5: 'A5-Karten',
      back: 'Zurück',
      choose_qr: 'Wähle den QR-Code für deine Party',
      your_qr: 'Dein QR-Code für Anfragen',
      plan_free: 'GRATIS Plan',
      plan_pro: 'PRO Plan',
      qr_free_title: 'QR-Code – Kostenlose Version',
      qr_pro_title: 'QR-Code – Pro Version',
      included: 'Enthalten:',
      standard_form: 'Standard-Anfrageformular',
      realtime_list: 'Echtzeit-Anfrageliste',
      multi_lang: 'Mehrsprachig (FR/EN/ES/DE)',
      copy_link: 'Link kopieren',
      link_copied: 'Link kopiert!',
      download_error: 'Download-Fehler',
      pro_features: 'Pro Funktionen',
      tips_enabled: 'Trinkgelder aktiviert',
      event_stats: 'Event-Statistiken',
      custom_branding: 'Eigenes Branding',
      event_qrcodes: 'Event QR-Codes',
      no_event_qr: 'Keine Events mit QR-Code',
      create_event_hint: 'Erstelle ein PRO Event für einen dedizierten QR-Code',
      // Additional keys
      recommended: 'EMPFOHLEN',
      all_free_plan: 'Alles vom Gratis-Plan',
      dj_business_card: 'DJ Visitenkarte',
      tip_option: 'Trinkgeld-Option (PayPal/Wero)',
      detailed_stats: 'Detaillierte Statistiken',
      unique_event_qr: 'Einzigartige QR-Codes für Events',
      copied: 'Kopiert',
      // Pro locked section
      pro_version: 'Pro Version',
      unlock_pro: 'Schalte Event QR-Codes, erweiterte Statistiken und DJ Visitenkarte mit TrackVibes Pro frei.',
      upgrade_pro: 'Auf Pro upgraden',
      trial_info: '14 Tage kostenlos – Jederzeit kündbar',
      // Event QR section
      event_qr_title: 'Event QR-Codes',
      manage_events: 'Events verwalten',
      no_event_qr_hint: 'Erstelle ein Event, um einen einzigartigen QR-Code zu erhalten und Anfragen im Voraus zu sammeln',
      create_event_btn: 'Event erstellen',
      active: 'Aktiv',
      draft: 'Entwurf',
      requests_count: 'Anfrage',
      requests_count_plural: 'Anfragen',
      // Info box
      advance_collection: 'Vorab-Sammlung',
      advance_collection_desc: 'Teile den QR-Code eines Events vor dem Tag X. Gäste können ihre Anfragen im Voraus senden. Am Tag X aktiviere das Event, um alle Anfragen in deinem Dashboard zu sehen.',
      // Tips section
      usage_tips: 'Nutzungstipps',
      free_tip: 'Ideal für alle Arten von Partys',
      pro_tip: 'Perfekt für private Feiern und Hochzeiten',
      print_tip: 'Drucke den QR-Code aus und platziere ihn in der Nähe deines DJ-Pults'
    },
    pt: {
      title: 'Meus QR Codes',
      permanent_qr: 'QR Codes permanentes',
      event_qr: 'QR Codes de eventos',
      free_mode: 'Modo Grátis',
      free_desc: 'QR code universal para coletar pedidos',
      pro_mode: 'Modo Pro',
      pro_desc: 'Perfeito para festas privadas e casamentos',
      no_events: 'Nenhum evento com QR code',
      create_event: 'Crie um evento para gerar um QR code dedicado',
      open_form: 'Abrir formulário',
      download_a4: 'Cartaz A4',
      download_a5: 'Cartões A5',
      back: 'Voltar',
      choose_qr: 'Escolha o QR code para sua festa',
      your_qr: 'Seu QR code para receber pedidos',
      plan_free: 'Plano GRÁTIS',
      plan_pro: 'Plano PRO',
      qr_free_title: 'QR Code – Versão Grátis',
      qr_pro_title: 'QR Code – Versão Pro',
      included: 'Incluído:',
      standard_form: 'Formulário de pedido padrão',
      realtime_list: 'Lista de pedidos em tempo real',
      multi_lang: 'Multi-idioma (FR/EN/ES/DE)',
      copy_link: 'Copiar link',
      link_copied: 'Link copiado!',
      download_error: 'Erro ao baixar',
      pro_features: 'Recursos Pro',
      tips_enabled: 'Gorjetas ativadas',
      event_stats: 'Estatísticas de eventos',
      custom_branding: 'Marca personalizada',
      event_qrcodes: 'QR Codes por evento',
      no_event_qr: 'Nenhum evento com QR code',
      create_event_hint: 'Crie um evento PRO para gerar um QR code dedicado',
      // Additional keys
      recommended: 'RECOMENDADO',
      all_free_plan: 'Tudo do plano Grátis',
      dj_business_card: 'Cartão de visita DJ',
      tip_option: 'Opção de gorjeta (PayPal/Wero)',
      detailed_stats: 'Estatísticas detalhadas',
      unique_event_qr: 'QR codes únicos para eventos',
      copied: 'Copiado',
      // Pro locked section
      pro_version: 'Versão Pro',
      unlock_pro: 'Desbloqueie QR codes de eventos, estatísticas avançadas e cartão de visita DJ com TrackVibes Pro.',
      upgrade_pro: 'Mudar para Pro',
      trial_info: '14 dias grátis – Cancele a qualquer momento',
      // Event QR section
      event_qr_title: 'QR Codes de Eventos',
      manage_events: 'Gerenciar eventos',
      no_event_qr_hint: 'Crie um evento para obter um QR code único e coletar pedidos antecipadamente',
      create_event_btn: 'Criar evento',
      active: 'Ativo',
      draft: 'Rascunho',
      requests_count: 'pedido',
      requests_count_plural: 'pedidos',
      // Info box
      advance_collection: 'Coleta antecipada',
      advance_collection_desc: 'Compartilhe o QR code de um evento antes do dia D. Os convidados podem enviar pedidos antecipadamente. No dia D, ative o evento para ver todos os pedidos no seu painel.',
      // Tips section
      usage_tips: 'Dicas de uso',
      free_tip: 'Ideal para todos os tipos de festas',
      pro_tip: 'Perfeito para festas privadas e casamentos',
      print_tip: 'Imprima o QR code e coloque-o perto da sua cabine'
    }
  },

  // ==================== NAV ====================
  nav: {
    fr: {
      dashboard: 'Dashboard',
      events: 'Soirées',
      qrcodes: 'QR Codes',
      stats: 'Statistiques',
      settings: 'Paramètres',
      tips: 'Pourboires'
    },
    en: {
      dashboard: 'Dashboard',
      events: 'Events',
      qrcodes: 'QR Codes',
      stats: 'Statistics',
      settings: 'Settings',
      tips: 'Tips'
    },
    es: {
      dashboard: 'Panel',
      events: 'Eventos',
      qrcodes: 'Códigos QR',
      stats: 'Estadísticas',
      settings: 'Configuración',
      tips: 'Propinas'
    },
    de: {
      dashboard: 'Dashboard',
      events: 'Events',
      qrcodes: 'QR-Codes',
      stats: 'Statistiken',
      settings: 'Einstellungen',
      tips: 'Trinkgelder'
    },
    pt: {
      dashboard: 'Painel',
      events: 'Eventos',
      qrcodes: 'QR Codes',
      stats: 'Estatísticas',
      settings: 'Configurações',
      tips: 'Gorjetas'
    }
  },

  // ==================== MODALS ====================
  modals: {
    fr: {
      // Refuse modal (Dashboard)
      refuse_title: 'Refuser cette demande',
      refuse_subtitle: 'Choisis une raison pour informer le client',
      refuse_reason_played: 'Déjà passée pendant la soirée',
      refuse_reason_theme: 'Ne correspond pas au thème de la soirée',
      refuse_reason_requested: 'Déjà demandée par quelqu\'un d\'autre',
      refuse_confirm: 'Refuser la demande',
      
      // Create event modal
      create_title: 'Nouvelle soirée',
      create_subtitle: 'Configure les détails de ton événement',
      event_name: 'Nom de la soirée',
      event_name_placeholder: 'Mariage de Sophie & Thomas',
      event_type: 'Type d\'événement',
      event_date: 'Date',
      event_location: 'Lieu',
      event_location_placeholder: 'Château de Versailles',
      event_guests: 'Nombre d\'invités (estimé)',
      event_duration: 'Durée (heures)',
      create_confirm: 'Créer la soirée',
      
      // Authority preferences (Create/Edit)
      authority_title: 'Goûts du donneur d\'ordre',
      authority_subtitle: 'Optionnel - Aide tes invités à faire de bonnes demandes',
      authority_label: 'Qui donne les consignes ?',
      authority_label_placeholder: 'Les mariés, Le client, L\'organisateur...',
      authority_loves: 'Ce qu\'ils adorent',
      authority_loves_placeholder: 'Ajouter un style ou artiste aimé',
      authority_banned: 'Ce qu\'ils ne veulent PAS',
      authority_banned_placeholder: 'Ajouter un style ou artiste interdit',
      authority_add: 'Ajouter',
      
      // Activate event modal
      activate_title: 'Activer la soirée',
      activate_subtitle: 'Es-tu prêt à recevoir des demandes ?',
      activate_warning: 'Une fois activée, les invités pourront scanner le QR code et envoyer leurs demandes.',
      activate_confirm: 'Activer maintenant',
      
      // Close event modal
      close_title: 'Clôturer la soirée',
      close_subtitle: 'Tu as terminé ?',
      close_warning: 'La soirée sera archivée et les statistiques seront disponibles.',
      close_confirm: 'Clôturer',
      
      // Delete event modal
      delete_title: 'Supprimer la soirée',
      delete_subtitle: 'Cette action est irréversible',
      delete_warning: 'Toutes les demandes et statistiques seront définitivement supprimées.',
      delete_confirm: 'Supprimer définitivement',
      
      // Stats modal
      stats_title: 'Statistiques',
      stats_total_requests: 'Total des demandes',
      stats_played: 'Morceaux joués',
      stats_pending: 'En attente',
      stats_refused: 'Refusés',
      stats_top_styles: 'Top styles demandés',
      stats_top_artists: 'Artistes les plus demandés',
      stats_timeline: 'Timeline des demandes',
      stats_export: 'Exporter en PDF',
      
      // Edit event modal
      edit_title: 'Modifier la soirée',
      edit_subtitle: 'Mets à jour les informations',
      edit_confirm: 'Enregistrer les modifications',
      
      // Delete account modal (Settings)
      delete_account_title: 'Supprimer mon compte',
      delete_account_warning: 'Cette action est irréversible. Toutes tes données (événements, demandes, paramètres) seront définitivement supprimées.',
      delete_account_confirm: 'Oui, supprimer mon compte',
      
      // Changelog modal
      changelog_title: 'Nouveautés',
      changelog_subtitle: 'Dernières mises à jour de TrackVibes'
    },
    en: {
      // Refuse modal (Dashboard)
      refuse_title: 'Refuse this request',
      refuse_subtitle: 'Choose a reason to inform the client',
      refuse_reason_played: 'Already played during the party',
      refuse_reason_theme: 'Does not match the party theme',
      refuse_reason_requested: 'Already requested by someone else',
      refuse_confirm: 'Refuse request',
      
      // Create event modal
      create_title: 'New event',
      create_subtitle: 'Configure your event details',
      event_name: 'Event name',
      event_name_placeholder: 'Sophie & Thomas Wedding',
      event_type: 'Event type',
      event_date: 'Date',
      event_location: 'Location',
      event_location_placeholder: 'Versailles Castle',
      event_guests: 'Number of guests (estimated)',
      event_duration: 'Duration (hours)',
      create_confirm: 'Create event',
      
      // Authority preferences (Create/Edit)
      authority_title: 'Client preferences',
      authority_subtitle: 'Optional - Help your guests make good requests',
      authority_label: 'Who gives the instructions?',
      authority_label_placeholder: 'The couple, The client, The organizer...',
      authority_loves: 'What they love',
      authority_loves_placeholder: 'Add a loved style or artist',
      authority_banned: 'What they DON\'T want',
      authority_banned_placeholder: 'Add a banned style or artist',
      authority_add: 'Add',
      
      // Activate event modal
      activate_title: 'Activate event',
      activate_subtitle: 'Ready to receive requests?',
      activate_warning: 'Once activated, guests can scan the QR code and send their requests.',
      activate_confirm: 'Activate now',
      
      // Close event modal
      close_title: 'Close event',
      close_subtitle: 'Are you done?',
      close_warning: 'The event will be archived and statistics will be available.',
      close_confirm: 'Close event',
      
      // Delete event modal
      delete_title: 'Delete event',
      delete_subtitle: 'This action is irreversible',
      delete_warning: 'All requests and statistics will be permanently deleted.',
      delete_confirm: 'Delete permanently',
      
      // Stats modal
      stats_title: 'Statistics',
      stats_total_requests: 'Total requests',
      stats_played: 'Tracks played',
      stats_pending: 'Pending',
      stats_refused: 'Refused',
      stats_top_styles: 'Top requested styles',
      stats_top_artists: 'Most requested artists',
      stats_timeline: 'Request timeline',
      stats_export: 'Export to PDF',
      
      // Edit event modal
      edit_title: 'Edit event',
      edit_subtitle: 'Update information',
      edit_confirm: 'Save changes',
      
      // Delete account modal (Settings)
      delete_account_title: 'Delete my account',
      delete_account_warning: 'This action is irreversible. All your data (events, requests, settings) will be permanently deleted.',
      delete_account_confirm: 'Yes, delete my account',
      
      // Changelog modal
      changelog_title: 'What\'s new',
      changelog_subtitle: 'Latest TrackVibes updates'
    },
    es: {
      // Refuse modal (Dashboard)
      refuse_title: 'Rechazar esta solicitud',
      refuse_subtitle: 'Elige una razón para informar al cliente',
      refuse_reason_played: 'Ya se reprodujo durante la fiesta',
      refuse_reason_theme: 'No corresponde al tema de la fiesta',
      refuse_reason_requested: 'Ya solicitada por alguien más',
      refuse_confirm: 'Rechazar solicitud',
      
      // Create event modal
      create_title: 'Nuevo evento',
      create_subtitle: 'Configura los detalles de tu evento',
      event_name: 'Nombre del evento',
      event_name_placeholder: 'Boda de Sophie & Thomas',
      event_type: 'Tipo de evento',
      event_date: 'Fecha',
      event_location: 'Lugar',
      event_location_placeholder: 'Castillo de Versailles',
      event_guests: 'Número de invitados (estimado)',
      event_duration: 'Duración (horas)',
      create_confirm: 'Crear evento',
      
      // Authority preferences (Create/Edit)
      authority_title: 'Preferencias del cliente',
      authority_subtitle: 'Opcional - Ayuda a tus invitados a hacer buenas solicitudes',
      authority_label: '¿Quién da las instrucciones?',
      authority_label_placeholder: 'Los novios, El cliente, El organizador...',
      authority_loves: 'Lo que les encanta',
      authority_loves_placeholder: 'Agregar un estilo o artista favorito',
      authority_banned: 'Lo que NO quieren',
      authority_banned_placeholder: 'Agregar un estilo o artista prohibido',
      authority_add: 'Agregar',
      
      // Activate event modal
      activate_title: 'Activar evento',
      activate_subtitle: '¿Listo para recibir solicitudes?',
      activate_warning: 'Una vez activado, los invitados podrán escanear el código QR y enviar sus solicitudes.',
      activate_confirm: 'Activar ahora',
      
      // Close event modal
      close_title: 'Cerrar evento',
      close_subtitle: '¿Has terminado?',
      close_warning: 'El evento será archivado y las estadísticas estarán disponibles.',
      close_confirm: 'Cerrar evento',
      
      // Delete event modal
      delete_title: 'Eliminar evento',
      delete_subtitle: 'Esta acción es irreversible',
      delete_warning: 'Todas las solicitudes y estadísticas serán eliminadas permanentemente.',
      delete_confirm: 'Eliminar permanentemente',
      
      // Stats modal
      stats_title: 'Estadísticas',
      stats_total_requests: 'Total de solicitudes',
      stats_played: 'Canciones reproducidas',
      stats_pending: 'Pendientes',
      stats_refused: 'Rechazadas',
      stats_top_styles: 'Estilos más solicitados',
      stats_top_artists: 'Artistas más solicitados',
      stats_timeline: 'Línea de tiempo de solicitudes',
      stats_export: 'Exportar a PDF',
      
      // Edit event modal
      edit_title: 'Editar evento',
      edit_subtitle: 'Actualizar información',
      edit_confirm: 'Guardar cambios',
      
      // Delete account modal (Settings)
      delete_account_title: 'Eliminar mi cuenta',
      delete_account_warning: 'Esta acción es irreversible. Todos tus datos (eventos, solicitudes, configuración) serán eliminados permanentemente.',
      delete_account_confirm: 'Sí, eliminar mi cuenta',
      
      // Changelog modal
      changelog_title: 'Novedades',
      changelog_subtitle: 'Últimas actualizaciones de TrackVibes'
    },
    de: {
      // Refuse modal (Dashboard)
      refuse_title: 'Diese Anfrage ablehnen',
      refuse_subtitle: 'Wähle einen Grund, um den Kunden zu informieren',
      refuse_reason_played: 'Bereits während der Party gespielt',
      refuse_reason_theme: 'Passt nicht zum Party-Thema',
      refuse_reason_requested: 'Bereits von jemand anderem angefragt',
      refuse_confirm: 'Anfrage ablehnen',
      
      // Create event modal
      create_title: 'Neues Event',
      create_subtitle: 'Konfiguriere deine Event-Details',
      event_name: 'Event-Name',
      event_name_placeholder: 'Hochzeit von Sophie & Thomas',
      event_type: 'Event-Typ',
      event_date: 'Datum',
      event_location: 'Ort',
      event_location_placeholder: 'Schloss Versailles',
      event_guests: 'Anzahl der Gäste (geschätzt)',
      event_duration: 'Dauer (Stunden)',
      create_confirm: 'Event erstellen',
      
      // Authority preferences (Create/Edit)
      authority_title: 'Kundenpräferenzen',
      authority_subtitle: 'Optional - Hilf deinen Gästen, gute Anfragen zu stellen',
      authority_label: 'Wer gibt die Anweisungen?',
      authority_label_placeholder: 'Das Brautpaar, Der Kunde, Der Organisator...',
      authority_loves: 'Was sie lieben',
      authority_loves_placeholder: 'Einen geliebten Stil oder Künstler hinzufügen',
      authority_banned: 'Was sie NICHT wollen',
      authority_banned_placeholder: 'Einen verbotenen Stil oder Künstler hinzufügen',
      authority_add: 'Hinzufügen',
      
      // Activate event modal
      activate_title: 'Event aktivieren',
      activate_subtitle: 'Bereit, Anfragen zu empfangen?',
      activate_warning: 'Nach der Aktivierung können Gäste den QR-Code scannen und ihre Anfragen senden.',
      activate_confirm: 'Jetzt aktivieren',
      
      // Close event modal
      close_title: 'Event beenden',
      close_subtitle: 'Bist du fertig?',
      close_warning: 'Das Event wird archiviert und Statistiken werden verfügbar sein.',
      close_confirm: 'Event beenden',
      
      // Delete event modal
      delete_title: 'Event löschen',
      delete_subtitle: 'Diese Aktion ist unwiderruflich',
      delete_warning: 'Alle Anfragen und Statistiken werden dauerhaft gelöscht.',
      delete_confirm: 'Dauerhaft löschen',
      
      // Stats modal
      stats_title: 'Statistiken',
      stats_total_requests: 'Gesamtanfragen',
      stats_played: 'Gespielte Tracks',
      stats_pending: 'Ausstehend',
      stats_refused: 'Abgelehnt',
      stats_top_styles: 'Top angefragte Stile',
      stats_top_artists: 'Meistgefragte Künstler',
      stats_timeline: 'Anfragen-Zeitachse',
      stats_export: 'Als PDF exportieren',
      
      // Edit event modal
      edit_title: 'Event bearbeiten',
      edit_subtitle: 'Informationen aktualisieren',
      edit_confirm: 'Änderungen speichern',
      
      // Delete account modal (Settings)
      delete_account_title: 'Mein Konto löschen',
      delete_account_warning: 'Diese Aktion ist unwiderruflich. Alle deine Daten (Events, Anfragen, Einstellungen) werden dauerhaft gelöscht.',
      delete_account_confirm: 'Ja, mein Konto löschen',
      
      // Changelog modal
      changelog_title: 'Neuigkeiten',
      changelog_subtitle: 'Neueste TrackVibes-Updates'
    },
    pt: {
      // Refuse modal (Dashboard)
      refuse_title: 'Recusar este pedido',
      refuse_subtitle: 'Escolha um motivo para informar o cliente',
      refuse_reason_played: 'Já tocada durante a festa',
      refuse_reason_theme: 'Não corresponde ao tema da festa',
      refuse_reason_requested: 'Já pedida por outra pessoa',
      refuse_confirm: 'Recusar pedido',
      
      // Create event modal
      create_title: 'Novo evento',
      create_subtitle: 'Configure os detalhes do seu evento',
      event_name: 'Nome do evento',
      event_name_placeholder: 'Casamento de Sophie & Thomas',
      event_type: 'Tipo de evento',
      event_date: 'Data',
      event_location: 'Local',
      event_location_placeholder: 'Castelo de Versailles',
      event_guests: 'Número de convidados (estimado)',
      event_duration: 'Duração (horas)',
      create_confirm: 'Criar evento',
      
      // Authority preferences (Create/Edit)
      authority_title: 'Preferências do cliente',
      authority_subtitle: 'Opcional - Ajude seus convidados a fazer bons pedidos',
      authority_label: 'Quem dá as instruções?',
      authority_label_placeholder: 'Os noivos, O cliente, O organizador...',
      authority_loves: 'O que eles amam',
      authority_loves_placeholder: 'Adicionar um estilo ou artista favorito',
      authority_banned: 'O que eles NÃO querem',
      authority_banned_placeholder: 'Adicionar um estilo ou artista proibido',
      authority_add: 'Adicionar',
      
      // Activate event modal
      activate_title: 'Ativar evento',
      activate_subtitle: 'Pronto para receber pedidos?',
      activate_warning: 'Uma vez ativado, os convidados poderão escanear o QR code e enviar seus pedidos.',
      activate_confirm: 'Ativar agora',
      
      // Close event modal
      close_title: 'Encerrar evento',
      close_subtitle: 'Você terminou?',
      close_warning: 'O evento será arquivado e as estatísticas estarão disponíveis.',
      close_confirm: 'Encerrar evento',
      
      // Delete event modal
      delete_title: 'Excluir evento',
      delete_subtitle: 'Esta ação é irreversível',
      delete_warning: 'Todos os pedidos e estatísticas serão excluídos permanentemente.',
      delete_confirm: 'Excluir permanentemente',
      
      // Stats modal
      stats_title: 'Estatísticas',
      stats_total_requests: 'Total de pedidos',
      stats_played: 'Músicas tocadas',
      stats_pending: 'Pendentes',
      stats_refused: 'Recusados',
      stats_top_styles: 'Estilos mais pedidos',
      stats_top_artists: 'Artistas mais pedidos',
      stats_timeline: 'Linha do tempo de pedidos',
      stats_export: 'Exportar para PDF',
      
      // Edit event modal
      edit_title: 'Editar evento',
      edit_subtitle: 'Atualizar informações',
      edit_confirm: 'Salvar alterações',
      
      // Delete account modal (Settings)
      delete_account_title: 'Excluir minha conta',
      delete_account_warning: 'Esta ação é irreversível. Todos os seus dados (eventos, pedidos, configurações) serão excluídos permanentemente.',
      delete_account_confirm: 'Sim, excluir minha conta',
      
      // Changelog modal
      changelog_title: 'Novidades',
      changelog_subtitle: 'Últimas atualizações do TrackVibes'
    }
  }
};

// ==================== HELPER FUNCTION ====================
export function t(lang, section, key) {
  const language = SUPPORTED_LANGUAGES.includes(lang) ? lang : DEFAULT_LANGUAGE;
  
  if (translations[section] && translations[section][language]) {
    const value = translations[section][language][key];
    if (value !== undefined) return value;
  }
  
  // Fallback to French
  if (translations[section] && translations[section].fr) {
    return translations[section].fr[key] || key;
  }
  
  return key;
}

export default translations;
